import { Box, Grid, IconButton, TableCell, TableRow, TextareaAutosize, Tooltip, Typography } from '@mui/material'
import { clinicTheme } from 'api/api'
import $ from 'jquery'
import _ from 'lodash'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** API*/
import TreatmentProductApi from 'api/dentists/treatmentProduct.api'
import OperativeTypeApi from 'api/setting/treatments/operative-type.api'

/** UTILS || SLICE */
import * as modalSlice from 'app/slice/modal.slice'
import {
  ProductStickerType,
  StickerType,
  TreatmentStateInterface,
  checkApprovalRight,
  historyToothChart,
  isEditTootChart,
  loadPromotionTreatments,
  newStickerProduct,
  promotionsTreatments,
  setEditTootChart,
  setEditTootChartType,
  setIsLoading,
  setSummeryTreatments,
  setToothChartSelected,
  setTreatmentByKey,
  treatment,
} from 'app/slice/treatment.slice'
import useWindowSize from 'utils/useWindowSize'

/** COMPONENT */
import { swalWarning } from 'component/Alert/Swal'
import ButtonCustom from 'component/Button/ButtonCustom'
import InputTextField from 'component/Input/InputTextField'
import AutocompleteSelect from 'component/Select/AutocompleteSelect'
import TableCustom from 'component/Table/TableCustom'
import AlertProductOutOfStock, { AlertProductOutOfStockType } from 'component/Treatments/AlertProductOutOfStock'
import PopupManageProduct from 'component/Treatments/PopupManageProduct'
import PopupManageTreatmentCourse, { CURRENCY_UNIT } from 'component/Treatments/PopupManageTreatmentCourse'
import PopupMessage from 'component/Treatments/PopupMessage'
import PopupNextVisit from 'component/Treatments/PopupNextVisit'
import { DoctorsType } from 'features/treatments/treatmentsIndex'

/** CONSTANTS */
import { Icons, icons } from 'constants/images'
import { colors } from 'constants/theme'
import { getBranch, getClinicInfo, numberFormat, toBuddhistYear } from 'utils/app.utils'

/** STYLE */
import { ApprovalStatus } from 'api/approval/approval.api'
import TreatmentSummaryApi from 'api/dentists/treatment-summary.api'
import TreatmentApi, { FindDoctorFeeProps } from 'api/dentists/treatment.api'
import { selectMe } from 'app/slice/user.slice'
import IconGiftVoucher from 'assets/icon/icon-gift-voucher'
import IconPromotion from 'assets/icon/icon-promotion'
import HelperText from 'component/Input/HelperText'
import PopupCommission from 'component/Treatments/PopupCommission'
import { approvalStatusList } from 'features/approvel-list/approvel-list'
import * as UseStyled from 'features/treatments/SummaryTreatment/UseStyle'
import { useLocation } from 'react-router-dom'
import '../style.css'

type ResponsiveRenderDataProps = {
  onViewTreatmentsCourse?: () => void
  onViewManageProduct?: () => void
  onViewMessage?: (no: number) => void
  onViewNextVisit?: () => void
  onChange?: (e: any) => void
  no: number
  doctors?: DoctorsType[]
  doctorsSelect?: DoctorsType[]
  data?: any
  price?: number
  discount?: number
  additional?: number
  total?: number
  hasTreatment: 'PERMISS' | 'UNPERMISS'
  hasChangeTreatmentCost: 'PERMISS' | 'UNPERMISS'
  hasChangeTreatmentNote: 'PERMISS' | 'UNPERMISS'
  hasDeleteTreatment: 'PERMISS' | 'UNPERMISS'
  renderTreatmentNextVisit: string
  hasCommission: '1' | '0'
  handleCommission?: (data: any, hasCommission: '1' | '0', index: number) => void
  commission: number
  type: 'Treatment' | 'Payment' | 'HistoryTreatment' | 'RetrospectiveOrder' | 'RetrospectiveEdit'
  disabledItemName: boolean
  hasEditNextVisit?: boolean
  renderIconApproval?: React.ReactNode
  hasNoDf?: any
  errorMessage?: any
}

type ISummaryTreatment = {
  onSave?: (val: 'save') => void
  userId?: number
  patientCaseId?: number
  patientId?: number
  patientName?: string
  patientPhone?: string
  type: 'Treatment' | 'Payment' | 'HistoryTreatment' | 'RetrospectiveOrder' | 'RetrospectiveEdit'
  doctors: DoctorsType[]
  hasTreatment: 'PERMISS' | 'UNPERMISS'
  hasChangeTreatmentCost: 'PERMISS' | 'UNPERMISS'
  hasChangeTreatmentNote: 'PERMISS' | 'UNPERMISS'
  hasChangeProductPrice: 'PERMISS' | 'UNPERMISS'
  hasChangeProductDiscountAdditional: 'PERMISS' | 'UNPERMISS'
  hasDeleteTreatment: 'PERMISS' | 'UNPERMISS'
  hasEditNextVisit?: boolean
  isNhso?: boolean
  hasNoDf?: any
  errorMessage?: any
}

type ConfigModal = {
  type?: 'TreatmentsCourse' | 'ViewMessage' | 'NextVisit' | 'ManageProduct' | 'RetrospectiveEdit' | 'Commission'
  itemId?: number
  operative?: any
  doctorId?: number
  product?: any
  hasCommission?: '1' | '0'
}

export interface RawDiscountType {
  price: number
  qty: number
  discount: number
  discountUnit: string
  dfUnit: string
  dfAmount: number
  dfAmountNet?: number
  dfDiscountAmount: number
  dfDiscountUnit: string
  cfAmount: number
  cfDiscountAmount: number
  cfDiscountUnit: string
  additionalNet: number
  doctorFeeAmount: number
  clinicFeeAmount: number
  additional: number
  additionalUnit: string
  voucher?: any
  installment?: any
}

export interface RawAdditionalType {
  price: number
  qty: number
  additional: number
  additionalUnit: string
}

const initProductOutOfStock: AlertProductOutOfStockType = {
  type: 'medicine',
  name: '',
  code: '',
  qty: 0,
  unit: ''
}

export interface UpdateDFIF {
  dfAmount: any;
  cfAmount: any;
  dfUnit: any;
  dfAmountNet: number;
  cfAmountNet: number;
  promotionDiscount: number;
  dfPromotionDiscountAmount: number;
  cfPromotionDiscountAmount: number;
  voucherDiscount: number;
  dfVoucherDiscountAmount: number;
  cfVoucherDiscountAmount: number;
  total: number;
}
export default function SummaryTreatment(props: ISummaryTreatment) {
  const dispatch = useDispatch()
  const { t, i18n } = useTranslation()
  const treatments: TreatmentStateInterface = useSelector(treatment)
  const promotions = useSelector(promotionsTreatments)
  const branchInfo = getClinicInfo()
  const isEditTootCharts: any = useSelector(isEditTootChart)
  const historyToothCharts = useSelector(historyToothChart)
  const newStickerProducts: ProductStickerType[] = useSelector(newStickerProduct)
  const modal: boolean = useSelector(modalSlice.handleShow)
  const location = useLocation()
  const [load, setLoad] = useState(true)
  const user = useSelector(selectMe)

  const [width] = useWindowSize()
  const [configModal, setConfigModal] = useState<ConfigModal>({})
  const [popupProductOutOfStock, setPopupProductOutOfStock] = useState<AlertProductOutOfStockType>(initProductOutOfStock)

  const [dataCommission, setDataCommission] = useState<any>({})
  const [qtyNew, setQty] = useState<{ target: { name: string; value: number; }; index: number; }>({ target: { name: 'qty', value: 1 }, index: 0 })

  const approvalRight = useSelector(checkApprovalRight)

  /////
  const handleDelRefItemId = (data: any, id: string) => {
    if (typeof data === 'string') {
      const step1 = data.replace(/\\/g, '');
      const step2 = step1.replace(/^"|"$/g, '');
      const dataParse = JSON.parse(step2);
      const newData = dataParse?.filter((item: any) => item !== id)
      return newData
    }
    const newData = data?.filter((item: any) => item !== id)
    return newData
  }

  const handleDelRefItem = (data: any, itemsDel: any) => {
    if (itemsDel[0]?.refItemId && itemsDel[0]?.refItemId !== "") {
      const dataDel = data.map((item: any) => {
        if (item?.refItemId?.includes(itemsDel[0]?.refItemId)) {
          return { ...item, refItemId: [...handleDelRefItemId(item?.refItemId, itemsDel[0]?.refItemId)] }
        } else {
          return item
        }
      })
      const newData = dataDel.filter((item: any) => {
        if (item?.refItemId?.length !== 0) { return item }
      })
      return newData
    } else {
      return data
    }

  }

  const handleDiscard = async (id: number) => {
    const itemsDel: any = _.filter(treatments.summeryTreatments, (treatmentSummary, index: number) => index === id)

    const itemExtraDel = itemsDel[0]?.promotion?.length ? itemsDel[0]?.promotion.map((item: any) => {
      return item?.promotionBranchId
    }) : []
    const items = _.filter(treatments.summeryTreatments, (treatmentSummary, index: number) => {
      if (index !== id) {
        return treatmentSummary
      }
    })
    let newItems: any = []
    if (itemExtraDel?.length) {
      items.forEach((item: any) => {
        if (item?.promotion?.length) {
          const checkPromotion = item?.promotion.some((info: any) => itemExtraDel.includes(info?.promotionBranchId) && info?.promotionType && info?.promotionType !== 'EXTRA')
          const check = item?.promotion.every((info: any) => !itemExtraDel.includes(info?.promotionBranchId))
          if (checkPromotion) {
            const newData = { ...item, promotion: item?.promotion?.filter((i: any) => !itemExtraDel.includes(i?.promotionBranchId)) || [] }
            newItems.push(newData)
          } else if (check) {
            newItems.push(item)
          }
        } else {
          newItems.push(item)
        }
      })
    } else {
      newItems = items
    }
    console.log('props.isNhso', props.isNhso);


    if (props.isNhso) {
      const lastUpdate = await updateDFNsho({ list: newItems, hasNoDf: props.hasNoDf })
      console.log('lastUpdate', lastUpdate);
      newItems = lastUpdate

    }

    const toothChartSelected: any = []

    if (!_.isEmpty(newItems)) {
      _.map(newItems, (item, index) => {
        if (item.teethJson) toothChartSelected.push(JSON.parse(item.teethJson))
      })
    }

    const itemRecom = handleDelRefItem(treatments.patientRecommends, itemsDel) || []
    const itemDis = handleDelRefItem(treatments.patientDiagnosis, itemsDel) || []

    dispatch(setTreatmentByKey({ key: 'patientDiagnosis', value: itemDis }))
    dispatch(setTreatmentByKey({ key: 'patientRecommends', value: itemRecom }))
    dispatch(setTreatmentByKey({ key: 'summeryTreatments', value: newItems }))
    dispatch(setTreatmentByKey({ key: 'summeryProducts', value: [] }))
    dispatch(setToothChartSelected([...historyToothCharts, ...toothChartSelected]))
    dispatch(setEditTootChart(null))
    dispatch(setEditTootChartType(''))
  }

  const onViewTreatmentsCourse = (no: number, operative: any, doctorId: number) => {
    if (_.find(props.doctors, { userId: doctorId })?.userId) {
      setConfigModal({ type: 'TreatmentsCourse', itemId: no, operative: operative, doctorId: doctorId })
      dispatch(modalSlice.showModal())
    } else {
      return swalWarning(t('TREATMENT_SUMMARY.MESSAGE.PLS_SELECT_DOCTOR'), '', null)
    }
  }

  const loadOperative = async () => {
    if (load && treatments.summeryTreatments.length > 0) {
      const ids = treatments.summeryTreatments.map((item: any) => item.operativeId)
      setLoad(false)
      dispatch(setTreatmentByKey({
        key: 'summeryTreatments', value: treatments.summeryTreatments.map((item: any) => {
          return {
            ...item,
          }
        })
      }))
      dispatch(setTreatmentByKey({
        key: 'summeryTreatmentsOld', value: treatments.summeryTreatments.map((item: any) => {
          return {
            ...item,
          }
        })
      }))
    }
  }


  useEffect(() => {
    loadOperative()
  }, [treatments.summeryTreatments])

  const onViewManageProduct = async (itemId: number, item: any, sticker?: any) => {
    const stickerObj: any = JSON.parse(sticker)
    const checkSticker = () => {
      if (!stickerObj.itemId) { return itemProduct?.sticker }
      else { return sticker }
    }

    let itemProduct = _.find(newStickerProducts, { itemId: item.itemId })
    if ((item.tempOrderProductId || item.orderProductId) && props.patientCaseId) {
      await TreatmentProductApi.findStickerById(props.patientCaseId, item.itemId)
        .then(({ data }) => {
          itemProduct = data?.find((info: any) => info?.tempOrderProductId === item?.tempOrderProductId)
        })
        .catch(() => {
          return
        })
    }
    setConfigModal({ type: 'ManageProduct', itemId: itemId, product: { ...item, sticker: checkSticker() } })
    dispatch(modalSlice.showModal())
  }

  const onViewMessage = (no: number) => {
    setConfigModal({ type: 'ViewMessage', itemId: no })
    dispatch(modalSlice.showModal())
  }

  const onViewNextVisit = (no: number) => {
    setConfigModal({ type: 'NextVisit', itemId: no })
    dispatch(modalSlice.showModal())
  }


  const handleQtyStock = (value: string) => {
    if (value) {
      const valSticker: StickerType = JSON.parse(value)
      return valSticker.stock || 0
    } else return 0
  }

  const handleChange = async (e: any, index: number, isPin?: boolean | false, name?: string) => {
    const lists = _.merge([], treatments.summeryTreatments)
    const list = treatments.summeryTreatments[index]
    if (list) {
      dispatch(setIsLoading(true))

      if (e.target.name === 'qty') {
        const isOperative = list?.operativeTypeId ? true : false
        const stock = Number(list.stock) || Number(list.qtyStock) || handleQtyStock(list.sticker)
        const quantity = !e.target.value ? 0 : String(e.target.value).replace(/[^0-9.]/g, '')
        let newQty = Number(quantity)

        if (stock && Number(quantity) > Number(stock)) {
          newQty = stock
          setPopupProductOutOfStock({
            type: list.group === 'MEDICINE' ? 'medicine' : 'product',
            code: list.itemCode,
            name: list.itemName || list.itemNameEn,
            qty: list.stock || list.qtyStock || handleQtyStock(list.sticker),
            unit: list.itemUnitName || list.itemUnitNameEn
          })
          dispatch(modalSlice.showModal())
        }

        const rawAdditional: RawAdditionalType = {
          price: list.price,
          qty: newQty,
          additional: Number(list.additional),
          additionalUnit: list.additionalUnit
        }

        const rawDiscount = list
        // const rawDiscount: RawDiscountType = {
        //   price: list.price,
        //   qty: newQty,
        //   discount: Number(list.discount),
        //   discountUnit: list.discountUnit,
        //   dfUnit: list.dfUnit,
        //   dfAmount: Number(list.dfAmount),
        //   dfDiscountAmount: Number(list.dfDiscountAmount),
        //   dfDiscountUnit: list.dfDiscountUnit,
        //   cfAmount: Number(list.cfAmount),
        //   cfDiscountAmount: Number(list.cfDiscountAmount),
        //   cfDiscountUnit: list.cfDiscountUnit,
        //   additionalNet: renderSumAdditional(rawAdditional),
        //   doctorFeeAmount: list.doctorFeeAmount,
        //   clinicFeeAmount: list.clinicFeeAmount
        // }

        const discount = (!isOperative && rawDiscount.discount) || renderSumDiscount(rawDiscount) || 0
        const additional = (!isOperative && rawAdditional.additional) || renderSumAdditional(rawAdditional) || 0
        const total = !isOperative ? list.price * (newQty >= stock ? stock : newQty) - discount + additional : list.price * newQty - discount + additional

        if (props?.patientId && (props?.type === 'Payment' || props?.type === 'Treatment')) {
          // const summaryTreatments = _.merge([], treatments.summeryTreatments)
          lists[index] = { ...lists[index], qty: newQty, total: total }
          await dispatch(loadPromotionTreatments(props.patientId, lists))
        }
        dispatch(setSummeryTreatments({ index: index, key: 'qty', value: newQty }))
        dispatch(setSummeryTreatments({ index: index, key: 'total', value: total }))

        lists[index] = { ...lists[index], qty: newQty, total: total }

        /** Check Voucher ก่อนว่ายังเข้าเงื่อนไขมั้ย */
        if (list?.voucher) {
          const itemType = list.operativeName ? "OPERATIVE" : list.group
          const itemId = list.operativeId || list.itemId
          let voucher = promotions.find((item: any) => Number(item?.itemId) === Number(itemId) && item.itemType === itemType && Number(item.qty) === Number(newQty))?.vouchers
          voucher = voucher?.voucherPriceType === 'DISCOUNT' && voucher?.voucherUsage !== "ALL"

          if (!voucher) {
            // dispatch(setSummeryTreatments({ index: index, key: 'voucher', value: null }))
            // dispatch(setSummeryTreatments({ index: index, key: 'voucherDiscount', value: null }))
            // dispatch(setSummeryTreatments({ index: index, key: 'voucherDiscountUnit', value: 'BAHT' }))
            // dispatch(setSummeryTreatments({ index: index, key: 'voucherListId', value: null }))

            lists[index] = {
              ...lists[index], voucher: null,
              voucherDiscount: null,
              voucherDiscountUnit: 'BAHT',
              voucherListId: null
            }
          }
        }
        if (list?.operativeId) {
          const updateDF: UpdateDFIF | boolean = await updateDFValue({ ...lists[index], qty: newQty, hasNoDf: props.hasNoDf })
          if (updateDF) {
            lists[index] = {
              ...lists[index],
              total: updateDF.total,
              dfAmount: updateDF.dfAmount,
              dfUnit: updateDF.dfUnit,
              cfAmount: updateDF.cfAmount,
              dfAmountNet: updateDF.dfAmountNet,
              cfAmountNet: updateDF.cfAmountNet,
              doctorFeeAmount: updateDF.dfAmount,
              clinicFeeAmount: updateDF.cfAmount,
              promotionDiscount: updateDF.promotionDiscount,
              dfPromotionDiscountAmount: updateDF.dfPromotionDiscountAmount,
              cfPromotionDiscountAmount: updateDF.cfPromotionDiscountAmount,
              voucherDiscount: updateDF.voucherDiscount,
              dfVoucherDiscountAmount: updateDF.dfVoucherDiscountAmount,
              cfVoucherDiscountAmount: updateDF.cfVoucherDiscountAmount,
            }
          }
        }
        await dispatch(setTreatmentByKey({ key: 'summeryTreatments', value: lists }))
      } else if (e.target.name === 'doctorId' && treatments.summeryTreatments[0].pinDoctorId && e.target.value !== treatments.summeryTreatments[0].pinDoctorId) {
        await handlePinDoctor('unPin', 0)
        if (!list?.operativeId) {
          dispatch(setSummeryTreatments({ index: index, key: e.target.name, value: e.target.value }))
        }
        if (list?.operativeId) {
          const updateDF: UpdateDFIF | boolean = await updateDFValue({ ...lists[index], doctorId: e.target.value, hasNoDf: props.hasNoDf })
          if (updateDF) {
            lists[index] = {
              ...lists[index],
              doctorId: e.target.value,
              total: updateDF.total,
              dfAmount: updateDF.dfAmount,
              dfUnit: updateDF.dfUnit,
              cfAmount: updateDF.cfAmount,
              dfAmountNet: updateDF.dfAmountNet,
              cfAmountNet: updateDF.cfAmountNet,
              doctorFeeAmount: updateDF.dfAmount,
              clinicFeeAmount: updateDF.cfAmount,
              promotionDiscount: updateDF.promotionDiscount,
              dfPromotionDiscountAmount: updateDF.dfPromotionDiscountAmount,
              cfPromotionDiscountAmount: updateDF.cfPromotionDiscountAmount,
              voucherDiscount: updateDF.voucherDiscount,
              dfVoucherDiscountAmount: updateDF.dfVoucherDiscountAmount,
              cfVoucherDiscountAmount: updateDF.cfVoucherDiscountAmount,
            }
            dispatch(setTreatmentByKey({ key: 'summeryTreatments', value: lists }))
          }
        }
      } else if (e.target.name === 'doctorId') {
        if (!list?.operativeId) {
          dispatch(setSummeryTreatments({ index: index, key: e.target.name, value: e.target.value }))
        }
        if (list?.operativeId && !isPin) {
          const updateDF: UpdateDFIF | boolean = await updateDFValue({ ...lists[index], doctorId: e.target.value, hasNoDf: props.hasNoDf })
          if (updateDF) {
            lists[index] = {
              ...lists[index],
              doctorId: e.target.value,
              total: updateDF.total,
              dfAmount: updateDF.dfAmount,
              dfUnit: updateDF.dfUnit,
              cfAmount: updateDF.cfAmount,
              dfAmountNet: updateDF.dfAmountNet,
              cfAmountNet: updateDF.cfAmountNet,
              doctorFeeAmount: updateDF.dfAmount,
              clinicFeeAmount: updateDF.cfAmount,
              promotionDiscount: updateDF.promotionDiscount,
              dfPromotionDiscountAmount: updateDF.dfPromotionDiscountAmount,
              cfPromotionDiscountAmount: updateDF.cfPromotionDiscountAmount,
              voucherDiscount: updateDF.voucherDiscount,
              dfVoucherDiscountAmount: updateDF.dfVoucherDiscountAmount,
              cfVoucherDiscountAmount: updateDF.cfVoucherDiscountAmount,
            }
            dispatch(setTreatmentByKey({ key: 'summeryTreatments', value: lists }))
          }
        }
      } else {
        dispatch(setSummeryTreatments({ index: index, key: e.target.name || name, value: e.target.value }))
      }

      dispatch(setIsLoading(false))
    }
  }

  const handlePinDoctor = async (type: 'pin' | 'unPin', doctorId: number) => {
    dispatch(setIsLoading(true))
    const item = []
    for await (const treatmentSummary of treatments.summeryTreatments) {
      if (type === 'pin') {
        const editeDoctorId = treatmentSummary?.isEdit !== '0' ? doctorId : treatmentSummary.doctorId
        let total = treatmentSummary?.total || 0
        let dfAmount = treatmentSummary?.dfAmount || 0
        let dfUnit = treatmentSummary?.dfUnit || "BAHT"
        let cfAmount = treatmentSummary?.cfAmount || 0
        let dfAmountNet = treatmentSummary?.dfAmountNet || 0
        let cfAmountNet = treatmentSummary?.cfAmountNet || 0
        let doctorFeeAmount = treatmentSummary?.doctorFeeAmount || 0
        let clinicFeeAmount = treatmentSummary?.clinicFeeAmount || 0
        let promotionDiscount = treatmentSummary?.promotionDiscount || 0
        let dfPromotionDiscountAmount = treatmentSummary?.dfPromotionDiscountAmount || 0
        let cfPromotionDiscountAmount = treatmentSummary?.cfPromotionDiscountAmount || 0
        let voucherDiscount = treatmentSummary?.voucherDiscount || 0
        let dfVoucherDiscountAmount = treatmentSummary?.dfVoucherDiscountAmount || 0
        let cfVoucherDiscountAmount = treatmentSummary?.cfVoucherDiscountAmount || 0

        if (treatmentSummary?.operativeId && editeDoctorId !== treatmentSummary.doctorId) {
          const updateDF: UpdateDFIF | boolean | any = await updateDFValue({ ...treatmentSummary, doctorId: doctorId, hasNoDf: props.hasNoDf })
          if (updateDF) {
            total = updateDF.total || 0
            dfAmount = updateDF.dfAmount || 0
            dfUnit = updateDF.dfUnit || "BAHT"
            cfAmount = updateDF.cfAmount || 0
            dfAmountNet = updateDF.dfAmountNet || 0
            cfAmountNet = updateDF.cfAmountNet || 0
            doctorFeeAmount = updateDF.doctorFeeAmount || 0
            clinicFeeAmount = updateDF.clinicFeeAmount || 0
            promotionDiscount = updateDF.promotionDiscount || 0
            dfPromotionDiscountAmount = updateDF.dfPromotionDiscountAmount || 0
            cfPromotionDiscountAmount = updateDF.cfPromotionDiscountAmount || 0
            voucherDiscount = updateDF.voucherDiscount || 0
            dfVoucherDiscountAmount = updateDF.dfVoucherDiscountAmount || 0
            cfVoucherDiscountAmount = updateDF.cfVoucherDiscountAmount || 0
          }
        }

        item.push({
          ...treatmentSummary, doctorId: editeDoctorId, pinDoctorId: doctorId, total,
          dfAmount, dfUnit, cfAmount, dfAmountNet, cfAmountNet, doctorFeeAmount, clinicFeeAmount, promotionDiscount, dfPromotionDiscountAmount, cfPromotionDiscountAmount, voucherDiscount, dfVoucherDiscountAmount, cfVoucherDiscountAmount,
        })
      }
      else item.push({ ...treatmentSummary, pinDoctorId: null })
    }
    await dispatch(setTreatmentByKey({ key: 'summeryTreatments', value: item }))
    await dispatch(setIsLoading(false))
  }
  const onSubmitTreatmentsCourse = () => {
    return
  }

  const onRestPopup = () => {
    setConfigModal({})
    dispatch(modalSlice.resetModal())
    setPopupProductOutOfStock(initProductOutOfStock)
  }

  const handleRowHover = (type: 'onMouseEnter' | 'onMouseLeave', item: string) => {
    if (type === 'onMouseEnter') $(`#${item}`).prev().addClass('table-row-hover')
    else $(`#${item}`).prev().removeClass('table-row-hover')
  }

  const editToothChart = async (id: number) => {
    if (!treatments.summeryTreatments[id].teeth) {
      if (treatments.summeryTreatments[id].operativeTypeNameEn === 'NHSO') {
        $('.div-component').delay(500).animate({ scrollTop: 0 }, 500)
        dispatch(setSummeryTreatments({ index: id, key: 'color', value: treatments.summeryTreatments[id].color }))
        dispatch(setEditTootChartType(treatments.summeryTreatments[id].teethType))
        dispatch(setEditTootChart(id))
        if (props.type === 'RetrospectiveEdit') {
          const emrDetail = $('.emr-detail')
          const toothChart = $('.tooth-chart')
          emrDetail[0].scrollTo({ top: toothChart[0].offsetTop - 180, behavior: "smooth" })
        }
      } else {
        const resp: any = await OperativeTypeApi.findById(treatments.summeryTreatments[id].operativeTypeId)
        if (resp.status === 200) {
          $('.div-component').delay(500).animate({ scrollTop: 0 }, 500)
          dispatch(setSummeryTreatments({ index: id, key: 'color', value: resp.data.color }))
          dispatch(setEditTootChartType(treatments.summeryTreatments[id].teethType))
          dispatch(setEditTootChart(id))
          if (props.type === 'RetrospectiveEdit') {
            const emrDetail = $('.emr-detail')
            const toothChart = $('.tooth-chart')
            emrDetail[0].scrollTo({ top: toothChart[0].offsetTop - 180, behavior: "smooth" })
          }
        }
      }
    } else {
      $('.div-component').delay(500).animate({ scrollTop: 0 }, 500)
      dispatch(setEditTootChartType(treatments.summeryTreatments[id].teethType))
      dispatch(setEditTootChart(id))
      if (props.type === 'RetrospectiveEdit') {
        const emrDetail = $('.emr-detail')
        const toothChart = $('.tooth-chart')
        emrDetail[0].scrollTo({ top: toothChart[0].offsetTop - 180, behavior: "smooth" })
      }
    }
  }

  const renderTreatmentNextVisit = (value: any) => {
    let renderTreatment = typeof value === 'string' && value ? JSON.parse(value) : value
    if (typeof renderTreatment === 'string') {
      const step1 = renderTreatment.replace(/\\/g, '');
      const step2 = step1.replace(/^"|"$/g, '');
      renderTreatment = JSON.parse(step2)
    }

    if (!_.isEmpty(renderTreatment)) {
      return `${renderTreatment[0]?.operativeName || renderTreatment[0]?.operativeTypeName} ${_.size(renderTreatment) > 1
        ? t('TREATMENT_SUMMARY.POPUP.TREATMENT_NEXT_VISIT.TEMPLATE_MESSAGE.NEXT_VISIT_MORE_TREATMENT', {
          treatment_count: _.size(renderTreatment) - 1
        })
        : ''
        }`
    } else return ''
  }

  useEffect(() => {
    handleChange(qtyNew, qtyNew.index)
  }, [qtyNew]);

  const headCellsTooth = clinicTheme.theme === clinicTheme.type.DENTAL ? [{ id: 'message', disablePadding: false, label: t('TREATMENT_SUMMARY.TITLE.TOOTH'), width: '230px!important' }] : []
  const headCellsToothEmrEdit = clinicTheme.theme === clinicTheme.type.DENTAL ? [{ id: 'message', disablePadding: false, label: t('TREATMENT_SUMMARY.TITLE.TOOTH'), width: '110px' }] : []

  const headCells = [
    { id: 'no', disablePadding: false, label: '#' },
    ...headCellsTooth,
    {
      id: 'message', disablePadding: false, label: t('TREATMENT_SUMMARY.TITLE.TYPE'), width: `110px ${1600 > width ? '!important' : ''}`
    },
    { id: 'message', disablePadding: false, label: t('TREATMENT_SUMMARY.TITLE.SERVICE'), width: `155px ${1600 > width ? '!important' : ''} ` },
    { id: 'message', disablePadding: false, align: 'center', label: t('TREATMENT_SUMMARY.TITLE.QUANTITY') },
    { id: 'message', disablePadding: false, align: 'right', label: t('TREATMENT_SUMMARY.TITLE.NET_PRICE') },
    { id: 'message', disablePadding: false, align: 'left', label: t('TREATMENT_SUMMARY.TITLE.DOCTOR'), width: '350px !important' },
    { id: 'message', disablePadding: false, align: 'right', label: t('TREATMENT_SUMMARY.TITLE.DISCOUNT') },
    { id: 'message', disablePadding: false, align: 'right', label: t('TREATMENT_SUMMARY.TITLE.ADDON') },
    { id: 'message', disablePadding: false, align: 'right', label: t('TREATMENT_SUMMARY.TITLE.TOTAL') },
    { id: 'message', disablePadding: false, align: 'center', label: t('TREATMENT_SUMMARY.POPUP.COMMISSION.COMMISSION'), width: '110px' },
    { id: 'message', disablePadding: false, align: 'center', label: t('Action') }
  ]

  const headCellsEmrEdit = [
    { id: 'no', disablePadding: false, label: '#', width: '30px' },
    ...headCellsToothEmrEdit,
    { id: 'message', disablePadding: false, label: t('TREATMENT_SUMMARY.TITLE.TYPE'), width: '110px' },
    { id: 'message', disablePadding: false, label: t('TREATMENT_SUMMARY.TITLE.SERVICE'), width: '155px' },
    { id: 'message', disablePadding: false, align: 'center', label: t('TREATMENT_SUMMARY.TITLE.QUANTITY'), width: '85px' },
    { id: 'message', disablePadding: false, align: 'right', label: t('TREATMENT_SUMMARY.TITLE.NET_PRICE'), width: '100px' },
    { id: 'message', disablePadding: false, align: 'left', label: t('TREATMENT_SUMMARY.TITLE.DOCTOR'), width: '180px' },
    { id: 'message', disablePadding: false, align: 'right', label: t('TREATMENT_SUMMARY.TITLE.DISCOUNT'), width: '130px' },
    { id: 'message', disablePadding: false, align: 'right', label: t('TREATMENT_SUMMARY.TITLE.ADDON'), width: '130px' },
    { id: 'message', disablePadding: false, align: 'right', label: t('TREATMENT_SUMMARY.TITLE.TOTAL'), width: '130px' },
    { id: 'message', disablePadding: false, align: 'center', label: t('TREATMENT_SUMMARY.POPUP.COMMISSION.COMMISSION'), width: '110px' },
    { id: 'message', disablePadding: false, align: 'center', label: t('Action'), width: '65px' }
  ]

  const renderData = (data: any, no: number) => {
    const {
      operativeId,
      operativeTypeId,
      operativeTypeName,
      operativeTypeNameEn,
      operativeName,
      operativeNameEn,
      qty,
      doctorId,
      note,
      nextVisit,
      noteNextVisit,
      itemTypeName,
      itemTypeNameEn,
      itemName,
      itemNameEn,
      teeth,
      clinicFeeId,
      clinicFeeName,
      clinicFeeNameEn,
      clinicFeePrice,
      sticker,
      hasCommission,
      commission,
      refType,
      installment,
      operativeCode
    } = data
    const itemType = operativeName ? "OPERATIVE" : data?.group
    const itemId = operativeId || data.itemId
    const isEdit = branchInfo?.pdfInvoiceTreatmentCondition === '0' ? data?.isEdit : '1'
    const dataTreamtmentCurrent = (data?.approvalItems?.body && data?.approvalItems?.status === ApprovalStatus.PENDING) ? JSON.parse(data?.approvalItems?.body) : undefined
    const newData = dataTreamtmentCurrent || data

    let stickerProductUseDetail = ''
    let stickerDosage = ''
    let stickerProductUnitName = ''
    let stickerProductInstructionName = ''

    if (sticker) {
      const stickerObj: any = JSON.parse(sticker)
      const { productUseDetail, dosage, productUnitName, productInstructionName } = stickerObj
      stickerProductUseDetail = productUseDetail || ''
      stickerDosage = dosage || ''
      stickerProductUnitName = productUnitName || ''
      stickerProductInstructionName = productInstructionName || ''
    }

    const price = Number(newData.price || 0)
    const total = price <= 0 && newData.dfUnit !== 'PERCENT' && operativeTypeId ? 0 : Number(newData.total || 0)

    const rawAdditional: RawAdditionalType = {
      price: price,
      qty: Number(newData.qty),
      additional: Number(newData.additional),
      additionalUnit: newData.additionalUnit
    }

    // const rawDiscount: RawDiscountType = {
    //   price: price,
    //   qty: Number(newData.qty),
    //   discount: Number(newData.discount),
    //   discountUnit: newData.discountUnit,
    //   dfUnit: newData.dfUnit,
    //   dfAmount: Number(newData.dfAmount),
    //   dfDiscountAmount: Number(newData.dfDiscountAmount),
    //   dfDiscountUnit: newData.dfDiscountUnit,
    //   cfAmount: Number(newData.cfAmount),
    //   cfDiscountAmount: Number(newData.cfDiscountAmount),
    //   cfDiscountUnit: newData.cfDiscountUnit,
    //   additionalNet: renderSumAdditional(rawAdditional),
    //   doctorFeeAmount: newData.doctorFeeAmount,
    //   clinicFeeAmount: newData.clinicFeeAmount
    // }

    const rawDiscount = data

    let tooltipServiceName = false
    let tooltipServiceType = false
    const handleTooltip = () => {
      const textServiceName = document.querySelector(`.service-name-${operativeId}`)
      if (textServiceName) {
        const textElement = textServiceName.querySelector('.serivce-name')
        if (textElement) {
          if (textElement.scrollWidth > textServiceName.clientWidth) {
            tooltipServiceName = true
          } else {
            tooltipServiceName = false
          }
        }
      }
      const textServicetype = document.querySelector(`.service-type-${operativeId}`)
      if (textServicetype) {
        const textElement = textServicetype.querySelector('p')
        if (textElement) {
          if (textElement.scrollWidth > textServicetype.clientWidth) {
            tooltipServiceType = true
          } else {
            tooltipServiceType = false
          }
        }
      }
    }

    handleTooltip()

    const renderDoctors = () => {
      const pinDoctor = _.find(props.doctors, { userId: treatments?.summeryTreatments[0]?.pinDoctorId })
      if (pinDoctor) {
        const filterDoctor = _.filter(props.doctors, (d) => d.userId !== pinDoctor.userId)
        return [pinDoctor, ...filterDoctor]
      } else return props.doctors
    }

    const handleDisabledMedAndPd = (status: 'Create' | 'Delete') => {
      if (props.type !== 'Payment' && props.type !== 'RetrospectiveOrder') return props.type === 'RetrospectiveEdit' ? true : false
      else if (data?.group) {
        if (data?.group === "MEDICINE") return user?.[`has${status}Med`] !== 'PERMISS' ? true : false
        if (data?.group === "PRODUCT") return user?.[`has${status}Product`] !== 'PERMISS' ? true : false
        return false
      } else {
        if (status === 'Delete') return props?.hasDeleteTreatment === 'PERMISS' ? false : true
        return false
      }
    }

    const disabledItemName = handleDisabledMedAndPd('Create')
    const disabledDelItem = handleDisabledMedAndPd('Delete')

    // nextVisit
    const handleDisabledNextVisit = () => {
      if (props.type === 'RetrospectiveEdit')
        if (nextVisit) return nextVisit?.statusAppointment === 'DONE'
        else return false
      else return false
    }

    const disabledNextVisit = handleDisabledNextVisit()

    const disabledCourse = refType === 'COURSE' && user?.hasDeleteTreatmentCourse !== 'PERMISS' && props.type === 'Payment'
    const disabledPlan = refType === 'PLAN' && user?.hasDeleteTreatmentPlan !== 'PERMISS' && props.type === 'Payment'
    const renderIconApproval = (((props.type === 'Payment' || props.type === 'Treatment' || props.type === 'RetrospectiveOrder') && approvalRight?.hasChangeCost) && Object.values(ApprovalStatus).includes(data?.approvalItems?.status) && (data?.approvalItems?.status !== ApprovalStatus.CANCEL)) ? <Box sx={{ marginLeft: '4px' }}>{approvalStatusList[data?.approvalItems?.status as ApprovalStatus]?.icon}</Box> : <></>
    const disabledApproval = (data?.approvalItems?.status === ApprovalStatus?.PENDING) && approvalRight?.hasChangeCost


    const disabledPromotionExtra = data?.promotion?.length ? data?.promotion.some((item: any) => item?.promotionType === "EXTRA") : false
    const usablePromotions = promotions?.length ? promotions.find((item: any) => item?.itemId === operativeId || item?.itemId === data?.itemId)?.promotions : []
    const checkPromotions = usablePromotions?.length > 0


    const usableVoucher = promotions?.length ? promotions.find((item: any) => Number(item?.itemId) === Number(itemId) && item.itemType === itemType && Number(item.qty) === Number(qty))?.vouchers : []
    const checkVouchers = usableVoucher?.length ? usableVoucher.filter((item: any) => (item.minimum <= (Number(qty) * Number(price)))).length : false
    const checkInstallmentEdit = installment?.refType !== "ORDER"

    return (
      <>
        <TableRow key={`treatment-${no}`} className={`main-table-row`}>
          <TableCell align="center" scope="row" className="pt-3 pt-sm-4 pt-xl-2">
            {no + 1}
          </TableCell>
          <TableCell align="left" scope="row" colSpan={width >= 1200 ? 1 : _.size(headCells) - 1} className={`pt-3 pt-xl-2`}>
            <Box className="d-flex align-items-sm-center d-xl-block">
              {(clinicTheme.theme === clinicTheme.type.DENTAL && (
                <>
                  {width < 1200 && <UseStyled.Title className="d-inline-block pr-2">{t('TREATMENT_SUMMARY.TITLE.TOOTH')}</UseStyled.Title>}
                  {(operativeTypeId || data?.operativeTypeNameEn === 'NHSO') && (
                    <UseStyled.InputToothChart className={`d-sm-flex w-100 text-nowrap ${isEdit === '0' ? 'pe-none' : ''}`}>
                      <InputTextField disabled value={teeth || ''} helperText={(props.errorMessage?.teeth && !teeth) ? props.errorMessage?.teeth : ''} />
                      <UseStyled.BtnEditToothChart disableFocusRipple disableRipple onClick={() => ((!disabledPromotionExtra && checkInstallmentEdit) || data?.operativeTypeNameEn === 'NHSO') && editToothChart(no)} className={`p-0 ml-2 ${isEditTootCharts === no ? 'active' : ''} ${props.hasTreatment === 'UNPERMISS' ? 'd-none' : ''}`}>
                        {isEditTootCharts === no ? <Icons.ToothSolid /> : <Icons.ToothOutlined />}
                      </UseStyled.BtnEditToothChart>
                    </UseStyled.InputToothChart>
                  ) || <Typography sx={{ flex: 1 }}>-</Typography>}
                </>
              )) || (
                  <>
                    {width < 1200 && <UseStyled.Title className="d-inline-block pr-2">{t('TREATMENT_SUMMARY.TITLE.TYPE')}</UseStyled.Title>}
                    <Typography className="text-ellipsis" sx={{ flex: 1 }}>
                      {operativeTypeId ? operativeTypeName || operativeTypeNameEn || '-' : itemTypeName || itemTypeNameEn || '-'}
                    </Typography>
                  </>
                )}
              {width < 1200 && (
                <IconButton
                  disableFocusRipple
                  disableRipple
                  hidden={disabledDelItem && props.type !== 'RetrospectiveEdit'}
                  disabled={(disabledDelItem) || disabledCourse || disabledPlan || disabledApproval || disabledPromotionExtra || data?.operativeCode === '2330011'}
                  onClick={() => handleDiscard(no)}
                  className={`p-0 align-self-start mr-2 ml-3 ${isEdit === '0' ? 'pe-none' : ''}`}
                  sx={{
                    backgroundColor: 'transparent',
                    filter: (isEdit === '0' || disabledDelItem || disabledCourse || disabledPlan || disabledApproval || disabledPromotionExtra) || data?.operativeCode === '2330011' ? 'grayscale(1)' : 'grayscale(0)',
                    opacity: (isEdit === '0' || disabledDelItem || disabledCourse || disabledPlan || disabledApproval || disabledPromotionExtra) || data?.operativeCode === '2330011' ? 0.5 : 1
                  }}
                >
                  <img src={icons.btnMinus} alt="discard" />
                </IconButton>
              )}
            </Box>
            {width < 1200 && (
              <ResponsiveRenderData
                no={no}
                onViewTreatmentsCourse={() => onViewTreatmentsCourse(no, data, doctorId)}
                onViewManageProduct={() => onViewManageProduct(no, data, sticker)}
                onViewMessage={() => onViewMessage(no)}
                onViewNextVisit={() => onViewNextVisit(no)}
                hasEditNextVisit={disabledNextVisit || false}
                onChange={(e: any) => handleChange(e, no)}
                data={data}
                hasNoDf={props.hasNoDf}
                doctors={props.doctors}
                doctorsSelect={renderDoctors()}
                price={price || 0}
                discount={Number((operativeTypeId && renderSumDiscount(rawDiscount)) || cal_sum(newData, rawDiscount.discount, 'discount') || 0)}
                additional={Number((operativeTypeId && renderSumAdditional(rawAdditional)) || cal_sum(newData, rawAdditional.additional, 'additional') || 0)}
                total={cal_sum(newData, total, 'total')}
                hasTreatment={props.hasTreatment}
                hasChangeTreatmentCost={props.hasChangeTreatmentCost}
                hasChangeTreatmentNote={props.hasChangeTreatmentNote}
                renderTreatmentNextVisit={renderTreatmentNextVisit(nextVisit?.treatment)}
                hasDeleteTreatment={props.hasDeleteTreatment || 'PERMISS'}
                hasCommission={hasCommission}
                handleCommission={handleCommission}
                commission={commission || 0}
                type={props.type}
                disabledItemName={disabledItemName}
                renderIconApproval={renderIconApproval}
                errorMessage={props.errorMessage}
              />
            )}
          </TableCell>
          {width >= 1200 && (
            <>
              {clinicTheme.theme === clinicTheme.type.DENTAL && <>
                {!tooltipServiceType && (
                  <TableCell align="left" scope="row" className={`service-type-${operativeId}`}>
                    <Typography className="text-ellipsis">{operativeTypeId ? operativeTypeName || operativeTypeNameEn || '-' : itemTypeName || itemTypeNameEn || '-'}</Typography>
                  </TableCell>
                )}
                {tooltipServiceType && (
                  <Tooltip title={operativeTypeId ? operativeTypeName || operativeTypeNameEn || '-' : itemTypeName || itemTypeNameEn || '-'} placement="top">
                    <TableCell align="left" scope="row" className={`service-type-${operativeId}`}>
                      <Typography className="text-ellipsis">{operativeTypeId ? operativeTypeName || operativeTypeNameEn || '-' : itemTypeName || itemTypeNameEn || '-'}</Typography>
                    </TableCell>
                  </Tooltip>
                )}
              </>
              }
              <TableCell align="left" scope="row" className={`service-name-${operativeId}`}>
                <Box display={'flex'} alignItems={'center'}>
                  {checkVouchers ?
                    <Box marginRight={'4px'} display={'flex'} alignItems={'center'} minWidth={'fit-content'}
                      className={`p-0 text-left overflow-hidden ${props.hasChangeTreatmentCost === 'UNPERMISS' || isEdit === '0' || disabledPromotionExtra || data?.operativeTypeNameEn === 'NHSO' ? 'pe-none' : ''}`}
                      onClick={() => {
                        if (data?.operativeTypeNameEn !== 'NHSO') {
                          if (disabledItemName) {
                            return
                          }
                          if (operativeTypeId) onViewTreatmentsCourse(no, data, doctorId)
                          else onViewManageProduct(no, data, sticker)
                        }
                      }}
                      sx={{ cursor: 'pointer' }}
                    >
                      <IconGiftVoucher />
                    </Box> : ""
                  }
                  {(checkPromotions && !disabledPromotionExtra) &&
                    <Box marginRight={'4px'} display={'flex'} alignItems={'center'} minWidth={'fit-content'}
                      className={`p-0 text-left overflow-hidden ${props.hasChangeTreatmentCost === 'UNPERMISS' || isEdit === '0' || disabledPromotionExtra || data?.operativeTypeNameEn === 'NHSO' ? 'pe-none' : ''}`}
                      onClick={() => {
                        if (data?.operativeTypeNameEn !== 'NHSO') {
                          if (disabledItemName) {
                            return
                          }
                          if (operativeTypeId) onViewTreatmentsCourse(no, data, doctorId)
                          else onViewManageProduct(no, data, sticker)
                        }
                      }}
                      sx={{ cursor: 'pointer' }}
                    >
                      <IconPromotion />
                    </Box>
                  }
                  <UseStyled.ButtonOperative
                    disabled={disabledItemName ? true : false}
                    variant="text"
                    disableFocusRipple
                    disableElevation
                    disableRipple
                    disableTouchRipple
                    onClick={() => {
                      if (data?.operativeTypeNameEn !== 'NHSO') {
                        if (operativeTypeId) onViewTreatmentsCourse(no, data, doctorId)
                        else onViewManageProduct(no, data, sticker)
                      }
                    }}
                    className={`p-0 text-left overflow-hidden ${props.hasChangeTreatmentCost === 'UNPERMISS' || disabledPromotionExtra || data?.operativeTypeNameEn === 'NHSO' ? 'pe-none' : ''}`}
                    startIcon={renderIconApproval}
                  >
                    {(disabledPromotionExtra) &&
                      <Box component={'span'}>
                        {t('PROMOTION.MODAL_MANAGE.EXTRA')}
                      </Box>
                    }
                    {!tooltipServiceName && (
                      <span className="text-ellipsis serivce-name" style={{ textTransform: 'none', textDecoration: props.hasChangeTreatmentCost === 'UNPERMISS' || data?.operativeTypeNameEn === 'NHSO' ? '' : 'underline' }}>
                        {operativeCode} {operativeName || operativeNameEn || itemName || itemNameEn}
                      </span>
                    )}
                    {tooltipServiceName && (
                      <Tooltip title={operativeName || operativeNameEn || itemName || itemNameEn} placement="top">
                        <span className="text-ellipsis serivce-name" style={{ textTransform: 'none', textDecoration: props.hasChangeTreatmentCost === 'UNPERMISS' || data?.operativeTypeNameEn === 'NHSO' ? '' : 'underline' }}>
                          {operativeCode} {operativeName || operativeNameEn || itemName || itemNameEn}
                        </span>
                      </Tooltip>
                    )}
                  </UseStyled.ButtonOperative>
                  {newData?.group === 'MEDICINE' && <div>{`${stickerProductInstructionName} ${stickerDosage} ${stickerProductUnitName} ${stickerProductUseDetail}`}</div>}
                </Box>
                {clinicFeeId && (
                  <Box>
                    <Typography className="d-inline" sx={{ fontWeight: 700 }}>
                      CF:
                    </Typography>
                    <Typography className="d-inline pl-2" sx={{ fontWeight: 500, color: colors.textLightGray }}>
                      {clinicFeeName || clinicFeeNameEn} ({numberFormat(clinicFeePrice || 0, 0)} {t('CURRENCY_CHANGE.TH')})
                    </Typography>
                  </Box>
                )
                }
              </TableCell >
              <TableCell align="center" scope="row">
                <InputTextField
                  name="qty"

                  inputProps={{ min: 1 }}
                  disabled={isEdit === '0' || disabledItemName || newData?.installment?.refType === 'ORDER' || newData?.installment || disabledPromotionExtra || (dataTreamtmentCurrent && approvalRight?.hasChangeCost) ? true : false || data?.operativeTypeNameEn === 'NHSO'}
                  // onchange={async (e: any) => {
                  //   const inputValue = Number(e.target.value)
                  //   const resp = await TreatmentApi.getTxc(Number(props.patientId))
                  //   if (resp.status === 200) {
                  //     console.log('resp.data', resp.data)
                  //     console.log('data', data)
                  //     const arrayPatientTreatmentCourse = _.find(resp.data, (item) => item?.patientTreatmentCourseId === data?.patientTreatmentCourseId)
                  //     const treatmentCourse = _.find(arrayPatientTreatmentCourse?.patientTreatmentCourseItems, (item) => item?.itemId === data?.operativeId)
                  //     const totalQty = treatments.summeryTreatments.filter((item: any, index: number) => item.operativeId === data?.operativeId && index !== no)
                  //       .reduce((sum: number, item: any) => sum + Number(item.qty || 0), 0)
                  //     const remainingQty = Math.max((treatmentCourse?.balance || 0) - totalQty, 0)
                  //     const finalQty = inputValue > remainingQty ? remainingQty : inputValue
                  //     setQty({
                  //       target: {
                  //         name: 'qty',
                  //         value: finalQty
                  //       },
                  //       index: no
                  //     })
                  //   }
                  // }}
                  onchange={async (e: any) => {
                    let newValue = e.target.value
                    newValue = newValue.replace(/[^0-9.]/g, '');
                    if (newValue.indexOf('.') !== newValue.lastIndexOf('.')) {
                      newValue = newValue.slice(0, newValue.lastIndexOf('.'));
                    }
                    if (data?.refType !== "COURSE") {
                      setQty({ target: { name: 'qty', value: newValue }, index: no })
                    } else {
                      const inputValue = Number(newValue)
                      const resp = await TreatmentApi.getTxc(Number(props.patientId))
                      if (resp.status === 200) {
                        const arrayPatientTreatmentCourse = _.find(
                          resp.data,
                          (item) => item?.patientTreatmentCourseId === data?.patientTreatmentCourseId
                        )
                        const treatmentCourse = _.find(
                          arrayPatientTreatmentCourse?.patientTreatmentCourseItems,
                          (item) => {
                            if (!data?.group) {
                              return item?.itemId === data?.operativeId || data?.inventoryId
                            } else {
                              return item?.itemId === data?.inventoryId
                            }
                          })
                        // รวม qty ของรายการอื่น ๆ ที่มี operativeId เดียวกัน แต่ไม่ใช่ refId ปัจจุบัน
                        const otherQty = treatments.summeryTreatments
                          .filter((item: any, index: number) => {
                            if (!data?.group) {
                              return item.operativeId === data?.operativeId && index !== no && item.patientTreatmentCourseId === data?.patientTreatmentCourseId
                            } else {
                              return item.inventoryId === data?.inventoryId && index !== no && item.patientTreatmentCourseId === data?.patientTreatmentCourseId
                            }
                          })
                          .reduce((sum: number, item: any) => sum + Number(item.qty || 0), 0)
                        // หายอดคงเหลือ
                        const remainingQty = Math.max((treatmentCourse?.balance || 0) - otherQty, 0)
                        // จำกัดค่าที่กรอก ไม่ให้เกินยอดคงเหลือ
                        const finalQty = Math.min(inputValue, remainingQty)

                        setQty({
                          target: {
                            name: 'qty',
                            value: finalQty
                          },
                          index: no
                        })
                      }
                    }
                  }}
                  // onkeypress={(e: any) => setQty({ target: { name: 'qty', value: e.target.value }, index: no })}
                  // onkeyup={(e: any) => setQty({ target: { name: 'qty', value: e.target.value }, index: no })}
                  value={newData?.qty || qty}
                  label={''}
                  inputTextAlign="right"
                  hideControl
                  helperText={qty === 0 ? 'qty' : ''}
                  style={{ '.MuiFormHelperText-root.Mui-error': { display: 'none' } }}
                />
              </TableCell>
              <TableCell align="right" scope="row">
                {numberFormat(newData?.installment?.installmentItemPrice || newData?.installment?.totalPinstallmentItemPricerice || price)}
                {/* {numberFormat(_.find(newData?.installment?.installmentList, (item) => item.status === 'PENDING')?.price || price)} */}
              </TableCell>
              <TableCell align="left" scope="row">
                <AutocompleteSelect
                  labelId="sl-dentist"
                  options={renderDoctors()}
                  getOptionLabel={(option) => option.fullname}
                  renderOption={(props, option) => {
                    return (
                      <UseStyled.DentistList
                        {...props}
                        key={option.userId}
                        component="li"
                        className={`d-flex align-items-center justify-content-between w-100 cursor-pointer overflow-hidden`}
                        sx={{
                          pointerEvents: doctorHasOverDue(treatments, option.userId) ? 'none' : 'auto',
                          color: doctorHasOverDue(treatments, option.userId) ? colors.disabledGray : colors.textPrimary,
                          svg: {
                            filter: doctorHasOverDue(treatments, option.userId) ? 'grayscale(1)' : 'grayscale(0)'
                          }
                        }}
                      >
                        <div title={option.fullname} className="text-ellipsis w-100" onClick={() => handleChange({ target: { name: 'doctorId', value: option.userId } }, no)}>
                          <span className="text-ellipsis w-100">
                            {option.fullname}
                          </span>
                        </div>
                        <Box className="ml-2" onClick={() => {
                          handleChange({ target: { name: 'doctorId', value: option.userId } }, no, true)
                          handlePinDoctor('pin', option.userId)
                        }}>
                          <Icons.MarkLine active={option.userId === treatments?.summeryTreatments[0]?.pinDoctorId} />
                        </Box>
                      </UseStyled.DentistList>
                    )
                  }}
                  onchange={() => {
                    return
                  }}
                  noOptionsText={t('NOT_FOUND')}
                  filterOptions={(option) => option.fullname}
                  value={_.find(props.doctors, { userId: doctorId }) || null}
                  disableClearable
                  disabled={isEdit === '0' || props.type === 'RetrospectiveEdit' ? true : false}
                  params={{
                    ListboxProps: {
                      sx: {
                        maxHeight: '200px'
                      }
                    }
                  }}
                />
              </TableCell>
              <TableCell align="right" scope="row">
                {numberFormat(Number((operativeTypeId && renderSumDiscount(rawDiscount)) || cal_sum(newData, rawDiscount.discount, 'discount') || 0))} {t('CURRENCY_CHANGE.TH')}
              </TableCell>
              <TableCell align="right" scope="row">
                {numberFormat(Number((operativeTypeId && renderSumAdditional(rawAdditional)) || cal_sum(newData, rawAdditional.additional, 'additional') || 0))} {t('CURRENCY_CHANGE.TH')}
              </TableCell>
              <TableCell align="right" scope="row" sx={{ position: 'relative' }}>
                {((data?.promotion?.length || data?.voucher?.voucherListId) && data?.fullPrice && (Number(data?.fullPrice) !== Number(cal_sum(newData, total, 'total')))) ?
                  <Box color={'#808080'} fontSize={'12px'} sx={{ textDecorationLine: 'line-through' }}>{numberFormat(data?.fullPrice)}</Box>
                  : <></>
                }
                <Box display="flex" flexDirection="column">
                  <Typography lineHeight="20.8px" fontSize="16px" fontWeight={400}>{numberFormat(newData?.installment ? _.find(newData?.installment?.installmentList, (item) => item.status === 'PENDING')?.price : cal_sum(newData, total, 'total'))} {t('CURRENCY_CHANGE.TH')}</Typography>
                  {newData?.installment && <Typography lineHeight="15.6px" fontSize="12px" fontWeight={400} color="#808080">แบ่งชำระ: ({_.filter(newData.installment?.installmentList, (item) => item.status === 'PAID')?.length + 1}/{newData.installment?.installmentList?.length})</Typography>}
                </Box>
              </TableCell>
              <TableCell align="center" scope="row" >
                <div>
                  <ButtonCustom
                    onClick={() => handleCommission(data, hasCommission, no)}
                    disabled={isEdit === '0' || props.type === 'RetrospectiveEdit' || data?.operativeTypeNameEn === 'NHSO'}
                    style={{
                      width: i18n.language === 'th' ? "64px" : "100%",
                      height: i18n.language === 'th' ? "25px" : "100%",
                      '&.MuiButton-contained': {
                        padding: "0px !important",
                        height: '100%', width: '100%'
                      }
                    }}
                    textButton={t('TREATMENT_SUMMARY.POPUP.COMMISSION.COMMISSION')}
                  />
                  {commission && commission !== 0 &&
                    <div style={{ fontSize: "12px", color: "#929292", marginTop: "1px" }}>
                      {numberFormat(commission)} {t('CURRENCY_CHANGE.TH')}
                    </div> || <></>
                  }

                </div>
              </TableCell>
              <TableCell align="center" scope="row" className={`pt - 3 pt - sm - 4 pt - xl - 2`}>
                <IconButton
                  disableFocusRipple
                  disableRipple
                  hidden={disabledDelItem && props.type !== 'RetrospectiveEdit'}
                  disabled={(disabledDelItem) || disabledCourse || disabledPlan || disabledApproval || disabledPromotionExtra || data?.operativeCode === '2330011'}
                  onClick={() => handleDiscard(no)}
                  className={`p - 0 ${isEdit === '0' ? 'pe-none' : ''} `}
                  sx={{
                    backgroundColor: 'transparent',
                    filter: ((isEdit === '0' || disabledDelItem || disabledCourse || disabledPlan || disabledApproval || disabledPromotionExtra || data?.operativeCode === '2330011')) ? 'grayscale(1)' : 'grayscale(0)',
                    opacity: ((isEdit === '0' || disabledDelItem || disabledCourse || disabledPlan || disabledApproval || disabledPromotionExtra || data?.operativeCode === '2330011')) ? 0.5 : 1
                    // && props.type !== 'RetrospectiveOrder'
                  }}
                >
                  <img src={icons.btnMinus} alt="discard" />
                </IconButton>
              </TableCell>
            </>
          )}
        </TableRow >
        {width >= 1200 && (
          <TableRow key={`treatment-row-${no} `} id={`treatment-row-${no} `} onMouseEnter={() => handleRowHover('onMouseEnter', `treatment-row-${no} `)} onMouseLeave={() => handleRowHover('onMouseLeave', `treatment-row-${no} `)}>
            <TableCell align="center" scope="row" className="pt-1"></TableCell>
            <TableCell align="left" scope="row" colSpan={_.size(headCells) - 1} className="pt-1">
              <Box display="flex" flexDirection="row" width='100%' alignItems="center" gap="16px">
                <Box className={`${isEdit === '0' ? 'pe-none' : ''} w-100 d-flex`} sx={{ paddingRight: operativeTypeId ? '12px' : 0 }}>
                  <Typography>{t('TREATMENT_SUMMARY.TITLE.MORE_INFO')}</Typography>
                  <Box width='100%' display={'flex'} flexDirection={'column'}>
                    <UseStyled.InputFormControl className="ml-2 d-flex position-relative" sx={{ flex: 1 }}>
                      <TextareaAutosize
                        name="note"
                        disabled={props.hasChangeTreatmentNote === 'UNPERMISS' || isEdit === '0' ? true : false}
                        className={`input-form-note ${props.hasChangeTreatmentNote === 'UNPERMISS' || isEdit === '0' ? 'disabled' : ''}`}
                        value={note}
                        onChange={(e: any) => handleChange(e, no, false, 'note')}
                        minRows={2}
                        maxRows={10}
                        maxLength={data?.operativeTypeNameEn === 'NHSO' ? 1000 : 999999}
                      />
                      <Box className="input-form-note-wrap position-absolute " />
                      <ButtonCustom
                        disabled={props.hasChangeTreatmentNote === 'UNPERMISS' || isEdit === '0' ? true : false}
                        onClick={() => onViewMessage(no)}
                        textButton={<img src={icons.iconFeatherEdit} alt="" style={{ width: 24 }} />}
                        className="h-100"
                        style={{ margin: 0, height: '100%' }}
                      />
                    </UseStyled.InputFormControl >
                    {data?.operativeTypeNameEn === 'NHSO' && <Box sx={{ fontSize: '12px', color: colors.black60, zIndex: 999, transform: 'translate(85%,-20px)' }} >
                      {`${note?.length || 0}/1000`}
                    </Box>}
                    {(props.errorMessage?.note && !note) && <Box paddingLeft={1}><HelperText label={props.errorMessage?.note} /></Box>}
                  </Box>
                </Box>
                {operativeTypeId && (<Box className="w-100" sx={{ paddingLeft: '12px' }}>
                  <Box className="d-flex" sx={{ transform: data?.operativeTypeNameEn === 'NHSO' ? 'translateY(-10px)' : 'translateY(0px)' }}>
                    <Typography>{t('Next visit')}</Typography>
                    <UseStyled.InputFormControl className="ml-2 d-flex position-relative next-visit" sx={{ flex: 1 }}>
                      <TextareaAutosize
                        name="noteNextVisit"
                        className={`input-form-note ${isEdit === '0' ? 'pe-none disabled' : ''}`}
                        value={noteNextVisit}
                        onChange={(e: any) => handleChange(e, no, false, 'noteNextVisit')}
                        minRows={2}
                        maxRows={10}
                        maxLength={data?.operativeTypeNameEn === 'NHSO' ? 1000 : 999999}
                      />
                      <Box className="input-form-note-wrap position-absolute"></Box>
                      <ButtonCustom
                        onClick={() => onViewNextVisit(no)}
                        textButton={<img src={icons.iconCalendarPlus} alt="" style={{ width: 28 }} />}
                        className="h-100"
                        style={{ margin: 0, height: '100%' }}
                        disabled={(isEdit === '0' || disabledNextVisit) ? true : false}
                      />
                    </UseStyled.InputFormControl>
                  </Box>
                </Box>)}
              </Box>
              <Box display="flex" flexDirection="row" width='100%' alignItems="center" gap="16px">
                <Box width="50%"></Box>
                <Box width="50%">
                  {(!_.isEmpty(nextVisit) && (
                    <Box className="d-flex mt-2 mb-1">
                      <Typography sx={{ flex: 'none', opacity: 0 }}>{t('Next visit')}</Typography>
                      <Typography className="ml-2">
                        <span style={{ fontWeight: 600 }}>{t('TREATMENT_SUMMARY.TITLE.APPOINTMENT')} :</span>
                        <span className="ml-1" style={{ color: colors.textLightGray }}>{`${t('TREATMENT_SUMMARY.POPUP.TREATMENT_NEXT_VISIT.TEMPLATE_MESSAGE.NEXT_VISIT', {
                          date: nextVisit?.date ? toBuddhistYear(moment(nextVisit?.date), 'DD/MM/YYYY') : '-',
                          time: nextVisit?.timeStart ? toBuddhistYear(moment(nextVisit.timeStart, 'HH:mm'), 'HH:mm') : '-',
                          dentist: _.get(_.find(props.doctors, { userId: nextVisit?.doctorId }), 'fullname'),
                          treatment: renderTreatmentNextVisit(nextVisit?.treatment)
                        })}${disabledNextVisit ? t('TREATMENT_SUMMARY.POPUP.TREATMENT_NEXT_VISIT.TEMPLATE_MESSAGE.SUCCESS') : ''}`}</span>
                      </Typography>
                    </Box>
                  )) || <></>}
                </Box>
              </Box>
              {/* <Box display="flex" flexDirection="row" width='100%' alignItems="center" gap="16px">
                <Box width="50%" display="flex" flexDirection="row" alignItems="center">
                  <Typography width="100px">{t('TREATMENT_SUMMARY.TITLE.MORE_INFO')} {data?.operativeTypeNameEn === 'NHSO' && <span style={{ color: 'red' }}>*</span>}</Typography>
                  <Box width="100%" marginBottom={(props.errorMessage?.note && !note) ? '16px' : 0}>
                    <TextAreaButtonInput
                      onChange={(e: any) => handleChange(e, no, false, 'note')}
                      onClick={() => onViewMessage(no)}
                      value={note}
                      row={2}
                      fullWidth
                      maxLength={data?.operativeTypeNameEn === 'NHSO' ? 1000 : 999999}
                      icon={<img src={icons.iconFeatherEdit} alt="" style={{ width: 24 }} />}
                      disabled={props.hasChangeTreatmentNote === 'UNPERMISS' || isEdit === '0' ? true : false}
                      helperText={(props.errorMessage?.note && !note) ? props.errorMessage?.note : ''}
                      inputProps={{
                        startAdornment: (
                          <Box sx={{ position: "absolute", right: '12px', bottom: "2px" }}>
                            {data?.operativeTypeNameEn === 'NHSO' && <Box sx={{ fontSize: '12px', color: '#808080' }}>{`${note?.length || 0}/1000`}</Box>}
                          </Box>
                        ),
                      }}
                    />
                  </Box>
                </Box>
                <Box width="50%" display="flex" flexDirection="row" alignItems="center">
                  <Typography>{t('Next visit')}</Typography>
                  <Box width="100%">
                    <TextAreaButtonInput
                      onChange={(e: any) => handleChange(e, no, false, 'noteNextVisit')}
                      onClick={() => onViewNextVisit(no)}
                      value={noteNextVisit}
                      row={2}
                      fullWidth
                      icon={<img src={icons.iconCalendarPlus} alt="" style={{ width: 28 }} />}
                      disabled={(isEdit === '0' || disabledNextVisit) ? true : false}
                    />
                  </Box>
                </Box>
              </Box>
              <Box display="flex" flexDirection="row" width='100%' alignItems="center" gap="16px">
                <Box width="50%"></Box>
                <Box width="50%">
                  {(!_.isEmpty(nextVisit) && (
                    <Box className="d-flex mt-2 mb-1">
                      <Typography sx={{ flex: 'none', opacity: 0 }}>{t('Next visit')}</Typography>
                      <Typography className="ml-2">
                        <span style={{ fontWeight: 600 }}>{t('TREATMENT_SUMMARY.TITLE.APPOINTMENT')} :</span>
                        <span className="ml-1" style={{ color: colors.textLightGray }}>{`${t('TREATMENT_SUMMARY.POPUP.TREATMENT_NEXT_VISIT.TEMPLATE_MESSAGE.NEXT_VISIT', {
                          date: nextVisit?.date ? toBuddhistYear(moment(nextVisit?.date), 'DD/MM/YYYY') : '-',
                          time: nextVisit?.timeStart ? toBuddhistYear(moment(nextVisit.timeStart, 'HH:mm'), 'HH:mm') : '-',
                          dentist: _.get(_.find(props.doctors, { userId: nextVisit?.doctorId }), 'fullname'),
                          treatment: renderTreatmentNextVisit(nextVisit?.treatment)
                        })}${disabledNextVisit ? t('TREATMENT_SUMMARY.POPUP.TREATMENT_NEXT_VISIT.TEMPLATE_MESSAGE.SUCCESS') : ''}`}</span>
                      </Typography>
                    </Box>
                  )) || <></>}
                </Box>
              </Box> */}
            </TableCell >
            {clinicTheme.theme === clinicTheme.type.DENTAL && <TableCell align="center" scope="row" className="pt-1"></TableCell>}
          </TableRow >
        )
        }
      </>
    )
  }

  const handleCommission = async (data: any, hasCommission: '1' | '0', index: number) => {
    let CommissionInfo: any = {}
    const sumPrice = data.price * data.qty

    if (data.operativeId) {
      if (!data.tempOrderTreatmentId) {
        const patientState: any = location.state
        const servicePointId = patientState?.servicePointId
        const summeryTreatments: any = {
          ...data,
          servicePointId: servicePointId,
          clinicFeeId: Number(data.clinicFeeId) || null
        }
        await TreatmentSummaryApi.setTempOrderTreatment(props?.patientCaseId || 0, summeryTreatments)
          .then((res: any) => {
            const res_sumPrice = res.data.price * res.data.qty
            dispatch(setSummeryTreatments({ index: index, key: 'tempOrderTreatmentId', value: res.data.tempOrderTreatmentId }))
            CommissionInfo = {
              type: 'treatment',
              patientCaseId: props?.patientCaseId,
              code: res.data.operativeCode,
              itemName: res.data.operativeName,
              qty: res.data.qty,
              price: res.data.price,
              sum: res_sumPrice,
              tempOrderId: res.data.tempOrderTreatmentId,
              operativeId: res.data.operativeId
            }
          })
          .catch((e) => {
            return
          })
      } else {
        CommissionInfo = {
          type: 'treatment',
          patientCaseId: props?.patientCaseId,
          code: data.operativeCode,
          itemName: data.operativeName,
          qty: data.qty,
          price: data.price,
          sum: sumPrice,
          tempOrderId: data.tempOrderTreatmentId,
          operativeId: data.operativeId
        }
      }
    } else {
      if (data.group === 'MEDICINE') {
        CommissionInfo = {
          type: 'medicine',
          patientCaseId: props?.patientCaseId,
          code: data.itemCode,
          itemName: data.itemName,
          qty: data.qty,
          price: data.price,
          sum: sumPrice,
          tempOrderId: data.tempOrderProductId,
          operativeId: data.operativeId
        }
      } else {
        CommissionInfo = {
          type: 'product',
          patientCaseId: props?.patientCaseId,
          code: data.itemCode,
          itemName: data.itemName,
          qty: data.qty,
          price: data.price,
          sum: sumPrice,
          tempOrderId: data.tempOrderProductId,
          operativeId: data.operativeId
        }
      }
    }

    setDataCommission(CommissionInfo)
    setConfigModal({ type: 'Commission', hasCommission: hasCommission })
    dispatch(modalSlice.showModal())
  }

  useEffect(() => {
    if (!modal) onRestPopup()
  }, [modal])

  return (
    <Box>
      {props.type !== 'RetrospectiveEdit' && (
        <UseStyled.ResponsiveSummaryTreatmentTable className={'overflow-hidden custom-scroll'}>
          <TableCustom
            hidePagination
            customScroll
            page={0}
            pageLimit={0}
            sortType={'ASC'}
            sortBy={''}
            rowCount={0}
            textEmptyData={t('REGISTER.NO_ITEM')}
            onSort={() => {
              return
            }}
            setPageLimit={() => {
              return
            }}
            setPage={() => {
              return
            }}
            headCells={headCells}
            rowsData={_.map(treatments.summeryTreatments, (i, index: number) => {
              return renderData(i, index)
            }).reverse()}
          />
        </UseStyled.ResponsiveSummaryTreatmentTable>
      )}
      {props.type === 'RetrospectiveEdit' && (
        <UseStyled.ResponsiveSummaryTreatmentTableEmrEdit className={'overflow-hidden custom-scroll'}>
          <TableCustom
            hidePagination
            customScroll
            page={0}
            pageLimit={0}
            sortType={'ASC'}
            sortBy={''}
            rowCount={0}
            textEmptyData={t('REGISTER.NO_ITEM')}
            onSort={() => {
              return
            }}
            setPageLimit={() => {
              return
            }}
            setPage={() => {
              return
            }}
            headCells={headCellsEmrEdit}
            rowsData={_.map(treatments.summeryTreatments, (i, index: number) => {
              return renderData(i, index)
            }).reverse()}
          />
        </UseStyled.ResponsiveSummaryTreatmentTableEmrEdit>
      )}

      {props.type !== 'Payment' && props.type !== 'RetrospectiveOrder' && (
        <UseStyled.NetPrice className={`d-flex align-items-center justify-content-between justify-content-md-end mt-2 px-3 px-md-4`}>
          {t('TREATMENT_SUMMARY.TITLE.SUM_TOTAL')}
          <span className="pl-2 pl-md-5 text-right">
            {numberFormat(_.sumBy(treatments.summeryTreatments.map((item: any) => {
              let total = item?.installment ? _.find(item?.installment?.installmentList, (item) => item.status === 'PENDING')?.price : item.total
              if (item?.approvalItems?.status === ApprovalStatus.PENDING) {
                const newData = JSON.parse(item?.approvalItems?.body)
                total = newData?.total || 0
              }
              return { ...item, total }
            }), 'total') || 0)} {t('CURRENCY_CHANGE.TH')}
          </span>
        </UseStyled.NetPrice>
      )}

      {configModal.type === 'TreatmentsCourse' &&
        <PopupManageTreatmentCourse
          userId={configModal.doctorId}
          itemId={configModal.itemId}
          operative={configModal.operative}
          onSubmit={onSubmitTreatmentsCourse}
          onReset={onRestPopup}
          patient={{ patientCaseId: props?.patientCaseId, patientName: props?.patientName, patientId: props?.patientId }}
          type={props.type}
          hasNoDf={props.hasNoDf}
        />
      }
      {configModal.type === 'ViewMessage' && <PopupMessage type="summaryTreatment" userId={props.userId} itemId={configModal.itemId} onReset={onRestPopup} />}
      {configModal.type === 'NextVisit' && <PopupNextVisit patient={{ patientId: props.patientId, patientName: props.patientName }} userId={props.userId} itemId={configModal.itemId} onReset={onRestPopup} />}
      {configModal.type === 'ManageProduct' && (
        <PopupManageProduct
          page={(props.type === 'Treatment' && 'Treatment') || (props.type === 'Payment' && 'Payment') || 'RetrospectiveOrder'}
          group={configModal.product?.group}
          type={'summaryTreatment'}
          index={configModal.itemId}
          item={configModal.product}
          patientCaseId={props.patientCaseId || 0}
          onCancel={onRestPopup}
          onSubmit={onRestPopup}
          patientPhone={props.patientPhone}
          patientName={props.patientName || ''}
          hasChangeProductPrice={props.hasChangeProductPrice}
          hasChangeProductDiscountAdditional={props.hasChangeProductDiscountAdditional}
          patientId={props?.patientId}
        />
      )}
      {configModal.type === 'Commission' && <PopupCommission data={dataCommission} onReset={onRestPopup} hasCommission={configModal.hasCommission} onSave={props?.onSave ? props?.onSave : undefined} />}
      {popupProductOutOfStock.name && <AlertProductOutOfStock type="product" name={popupProductOutOfStock.name} code={popupProductOutOfStock.code} qty={popupProductOutOfStock.qty} unit={popupProductOutOfStock.unit} />}
    </Box>
  )
}

function ResponsiveRenderData(props: ResponsiveRenderDataProps) {
  const { t, i18n } = useTranslation()
  const dispatch = useDispatch()
  const treatments: TreatmentStateInterface = useSelector(treatment)
  const approvalRight = useSelector(checkApprovalRight)
  const promotions = useSelector(promotionsTreatments)



  const {
    operativeId,
    operativeTypeId,
    operativeTypeName,
    operativeTypeNameEn,
    operativeName,
    operativeNameEn,
    qty,
    doctorId,
    note,
    nextVisit,
    noteNextVisit,
    itemTypeName,
    itemTypeNameEn,
    itemName,
    itemNameEn,
    isEdit,
    clinicFeeId,
    clinicFeeName,
    clinicFeeNameEn,
    clinicFeePrice
  } = props.data
  const [qtyNew, setQty] = useState({ target: { name: 'qty', value: qty } })

  // useEffect(() => {
  //   if (props.onChange) props.onChange({ target: { name: 'qty', value: qtyNew.target.value } })
  // }, [qtyNew])

  const itemType = operativeName ? "OPERATIVE" : props.data?.group
  const itemId = operativeId || props.data.itemId
  const dataTreamtmentCurrent = (props.data?.approvalItems?.body && props.data?.approvalItems?.status === ApprovalStatus.PENDING) ? JSON.parse(props.data?.approvalItems?.body) : undefined
  const newData = dataTreamtmentCurrent || props.data

  const handlePinDoctor = async (type: 'pin' | 'unPin', doctorId: number) => {
    dispatch(setIsLoading(true))
    const item = []
    for await (const treatmentSummary of treatments.summeryTreatments) {
      if (type === 'pin') {
        const editeDoctorId = treatmentSummary?.isEdit !== '0' ? doctorId : treatmentSummary.doctorId
        let total = treatmentSummary?.total || 0
        let dfAmount = treatmentSummary?.dfAmount || 0
        let dfUnit = treatmentSummary?.dfUnit || "BAHT"
        let cfAmount = treatmentSummary?.cfAmount || 0
        let dfAmountNet = treatmentSummary?.dfAmountNet || 0
        let cfAmountNet = treatmentSummary?.cfAmountNet || 0
        let doctorFeeAmount = treatmentSummary?.doctorFeeAmount || 0
        let clinicFeeAmount = treatmentSummary?.clinicFeeAmount || 0
        let promotionDiscount = treatmentSummary?.promotionDiscount || 0
        let dfPromotionDiscountAmount = treatmentSummary?.dfPromotionDiscountAmount || 0
        let cfPromotionDiscountAmount = treatmentSummary?.cfPromotionDiscountAmount || 0
        let voucherDiscount = treatmentSummary?.voucherDiscount || 0
        let dfVoucherDiscountAmount = treatmentSummary?.dfVoucherDiscountAmount || 0
        let cfVoucherDiscountAmount = treatmentSummary?.cfVoucherDiscountAmount || 0

        if (treatmentSummary?.operativeId && editeDoctorId !== treatmentSummary.doctorId) {
          const updateDF: UpdateDFIF | boolean | any = await updateDFValue({ ...treatmentSummary, doctorId: doctorId, hasNoDf: props.hasNoDf })
          if (updateDF) {
            total = updateDF.total || 0
            dfAmount = updateDF.dfAmount || 0
            dfUnit = updateDF.dfUnit || "BAHT"
            cfAmount = updateDF.cfAmount || 0
            dfAmountNet = updateDF.dfAmountNet || 0
            cfAmountNet = updateDF.cfAmountNet || 0
            doctorFeeAmount = updateDF.doctorFeeAmount || 0
            clinicFeeAmount = updateDF.clinicFeeAmount || 0
            promotionDiscount = updateDF.promotionDiscount || 0
            dfPromotionDiscountAmount = updateDF.dfPromotionDiscountAmount || 0
            cfPromotionDiscountAmount = updateDF.cfPromotionDiscountAmount || 0
            voucherDiscount = updateDF.voucherDiscount || 0
            dfVoucherDiscountAmount = updateDF.dfVoucherDiscountAmount || 0
            cfVoucherDiscountAmount = updateDF.cfVoucherDiscountAmount || 0
          }
        }

        item.push({
          ...treatmentSummary, doctorId: editeDoctorId, pinDoctorId: doctorId, total,
          dfAmount, dfUnit, cfAmount, dfAmountNet, cfAmountNet, doctorFeeAmount, clinicFeeAmount, promotionDiscount, dfPromotionDiscountAmount, cfPromotionDiscountAmount, voucherDiscount, dfVoucherDiscountAmount, cfVoucherDiscountAmount,
        })
      }
      else item.push({ ...treatmentSummary, pinDoctorId: null })
    }
    await dispatch(setTreatmentByKey({ key: 'summeryTreatments', value: item }))
    await dispatch(setIsLoading(false))
  }

  const handleChangeDoctor = async (id: number) => {
    dispatch(setIsLoading(true))
    if (treatments.summeryTreatments[0].pinDoctorId && id !== treatments.summeryTreatments[0].pinDoctorId) {
      await handlePinDoctor('unPin', 0)
      await dispatch(setSummeryTreatments({ index: props.no, key: 'doctorId', value: id }))
    } else await dispatch(setSummeryTreatments({ index: props.no, key: 'doctorId', value: id }))


    const list = treatments.summeryTreatments[props.no]
    if (list?.operativeId) {
      const lists = _.merge([], treatments.summeryTreatments)
      const updateDF: UpdateDFIF | boolean = await updateDFValue({ ...list, doctorId: id, hasNoDf: props.hasNoDf })
      if (updateDF) {
        lists[props.no] = {
          ...lists[props.no],
          doctorId: id,
          total: updateDF.total,
          dfAmount: updateDF.dfAmount,
          dfUnit: updateDF.dfUnit,
          cfAmount: updateDF.cfAmount,
          dfAmountNet: updateDF.dfAmountNet,
          cfAmountNet: updateDF.cfAmountNet,
          doctorFeeAmount: updateDF.dfAmount,
          clinicFeeAmount: updateDF.cfAmount,
          promotionDiscount: updateDF.promotionDiscount,
          dfPromotionDiscountAmount: updateDF.dfPromotionDiscountAmount,
          cfPromotionDiscountAmount: updateDF.cfPromotionDiscountAmount,
          voucherDiscount: updateDF.voucherDiscount,
          dfVoucherDiscountAmount: updateDF.dfVoucherDiscountAmount,
          cfVoucherDiscountAmount: updateDF.cfVoucherDiscountAmount,
        }
        await dispatch(setTreatmentByKey({ key: 'summeryTreatments', value: lists }))

      }
    }
    dispatch(setIsLoading(false))
  }

  const disabledPromotionExtra = props.data?.promotion?.length ? props.data?.promotion.some((item: any) => item?.promotionType === "EXTRA") : false
  const usablePromotions = promotions?.length ? promotions.find((item: any) => item?.itemId === operativeId || item?.itemId === props.data?.itemId)?.promotions : []
  const checkPromotions = usablePromotions?.length > 0




  const usableVoucher = promotions?.length ? promotions.find((item: any) => Number(item?.itemId) === Number(itemId) && item.itemType === itemType && Number(item.qty) === Number(qty))?.vouchers : []
  const checkVouchers = usableVoucher?.length ? usableVoucher.filter((item: any) => (item.minimum <= (Number(qty) * Number(props.data.price)))).length : false

  return (
    <>
      <Grid container spacing={2} alignItems="center" className="mt-0">
        {clinicTheme.theme === clinicTheme.type.DENTAL && (
          <Grid item xs={12} className="w-100">
            <Box className="d-flex align-items-start">
              <UseStyled.Title className="d-inline-block pr-2">{t('TREATMENT_SUMMARY.TITLE.TYPE')}</UseStyled.Title>
              <Typography>{operativeTypeId ? operativeTypeName || operativeTypeNameEn || '-' : itemTypeName || itemTypeNameEn || '-'}</Typography>
            </Box>
          </Grid>
        )}
        <Grid item xs={12} className={`w-100`}>
          <Box className="d-flex align-items-center">
            <UseStyled.Title className="d-inline-block pr-2">{t('TREATMENT_SUMMARY.TITLE.SERVICE')}</UseStyled.Title>
            {checkVouchers &&
              <Box marginRight={'4px'} display={'flex'} alignItems={'center'} minWidth={'fit-content'}
                className={`p-0 text-left overflow-hidden ${props.hasChangeTreatmentCost === 'UNPERMISS' || isEdit === '0' || disabledPromotionExtra || props.data?.operativeTypeNameEn === 'NHSO' ? 'pe-none' : ''}`}
                onClick={() => {
                  if (props.data?.operativeTypeNameEn !== 'NHSO') {
                    if (props.disabledItemName) return
                    if (operativeTypeId) props.onViewTreatmentsCourse && props.onViewTreatmentsCourse()
                    else props.onViewManageProduct && props.onViewManageProduct()
                    // if (operativeTypeId) props.onViewTreatmentsCourse!()
                    // else props.onViewManageProduct!()
                  }

                }}
                sx={{ cursor: 'pointer' }}
              >
                <IconGiftVoucher />
              </Box>

            }
            {(checkPromotions && !disabledPromotionExtra) &&
              <Box marginRight={'4px'} display={'flex'} alignItems={'center'}
                className={`p-0 text-left overflow-hidden ${props.hasChangeTreatmentCost === 'UNPERMISS' || isEdit === '0' || disabledPromotionExtra || props.data?.operativeTypeNameEn === 'NHSO' ? 'pe-none' : ''}`}
                onClick={() => {
                  if (props.data?.operativeTypeNameEn !== 'NHSO') {
                    if (props.disabledItemName) return
                    if (operativeTypeId) props.onViewTreatmentsCourse && props.onViewTreatmentsCourse()
                    else props.onViewManageProduct && props.onViewManageProduct()
                    // if (operativeTypeId) props.onViewTreatmentsCourse!()
                    // else props.onViewManageProduct!()
                  }
                }}
                sx={{ cursor: 'pointer' }}
              >
                <IconPromotion />
              </Box>
            }
            <UseStyled.ButtonOperative
              disabled={props.disabledItemName}
              variant="text"
              disableFocusRipple
              disableElevation
              disableRipple
              disableTouchRipple
              onClick={() => {
                if (props.data?.operativeTypeNameEn !== 'NHSO') {
                  if (operativeTypeId) props.onViewTreatmentsCourse && props.onViewTreatmentsCourse()
                  else props.onViewManageProduct && props.onViewManageProduct()
                }
              }}
              className={`p-0 text-left overflow-hidden ${props.hasChangeTreatmentCost === 'UNPERMISS' || (isEdit === '0' || props.disabledItemName) || props.data?.operativeTypeNameEn === 'NHSO' ? 'pe-none' : ''}`}
              startIcon={props.renderIconApproval}
            >
              {(disabledPromotionExtra) &&
                <Box component={'span'}>
                  {t('PROMOTION.MODAL_MANAGE.EXTRA')}
                </Box>
              }
              <span className="text-ellipsis" style={{ textDecoration: props.hasChangeTreatmentCost === 'UNPERMISS' || (isEdit === '0' || props.disabledItemName) || props.data?.operativeTypeNameEn === 'NHSO' ? '' : 'underline' }}>
                {operativeName || operativeNameEn || itemName || itemNameEn}
              </span>
            </UseStyled.ButtonOperative>
            {clinicFeeId && (
              <Box>
                <Typography className="d-inline" sx={{ fontWeight: 700 }}>
                  CF:
                </Typography>
                <Typography className="d-inline pl-2" sx={{ fontWeight: 500, color: colors.textLightGray }}>
                  {clinicFeeName || clinicFeeNameEn} ({numberFormat(clinicFeePrice || 0, 0)} {t('CURRENCY_CHANGE.TH')})
                </Typography>
              </Box>
            )}
          </Box>
        </Grid>
        <Grid item xs={6} className={`w-100 ${isEdit === '0' ? 'pe-none' : ''}`}>
          <Box className="d-flex align-items-center">
            <UseStyled.Title className="d-inline-block pr-2">{t('TREATMENT_SUMMARY.TITLE.QUANTITY')}</UseStyled.Title>
            <InputTextField
              inputProps={{ min: 1 }}
              name="qty"
              disabled={isEdit === '0' || props.disabledItemName || disabledPromotionExtra || (dataTreamtmentCurrent && approvalRight?.hasChangeCost || props.data?.operativeTypeNameEn === 'NHSO')}
              onchange={props.onChange}
              // onkeypress={(e) => setQty({ target: { name: 'qty', value: e.target.value } })}
              // onkeyup={(e) => setQty({ target: { name: 'qty', value: e.target.value } })}
              value={newData?.qty || qty}
              label={''}
              inputTextAlign="right"
              hideControl
              helperText={qty === 0 ? 'qty' : ''}
              style={{ maxWidth: '64px', '.MuiFormHelperText-root.Mui-error': { display: 'none' } }}
            />
          </Box>
        </Grid>
        <Grid item xs={6} className="w-100">
          <Box className="d-flex align-items-center">
            <UseStyled.Title className="d-inline-block pr-2">{t('TREATMENT_SUMMARY.TITLE.NET_PRICE')}</UseStyled.Title>
            <Typography>{numberFormat(props.price)}</Typography>
          </Box>
        </Grid>
        <Grid item xs={12} className={`w-100 ${isEdit === '0' ? 'pe-none' : ''}`}>
          <Box className="d-flex align-items-center">
            <UseStyled.Title className="d-inline-block pr-2">{t('TREATMENT_SUMMARY.TITLE.DOCTOR')}</UseStyled.Title>
            <Box className="w-100 overflow-hidden" sx={{ maxWidth: '240px' }}>
              <AutocompleteSelect
                labelId="sl-dentist"
                options={props.doctorsSelect}
                getOptionLabel={(option) => option.fullname}
                renderOption={(props, option) => {
                  return (
                    <UseStyled.DentistList
                      {...props}
                      key={option.userId}
                      component="li"
                      className={`d-flex align-items-center justify-content-between w-100 cursor-pointer overflow-hidden`}
                      sx={{
                        pointerEvents: doctorHasOverDue(treatments, option.userId) ? 'none' : 'auto',
                        color: doctorHasOverDue(treatments, option.userId) ? colors.disabledGray : colors.textPrimary,
                        svg: {
                          filter: doctorHasOverDue(treatments, option.userId) ? 'grayscale(1)' : 'grayscale(0)'
                        }
                      }}
                    >
                      <span onClick={async () => await handleChangeDoctor(option.userId)} className="text-ellipsis">
                        {option.fullname}
                      </span>
                      <Box className="ml-2" onClick={async () => handlePinDoctor('pin', option.userId)}>
                        <Icons.MarkLine active={option.userId === treatments?.summeryTreatments[0]?.pinDoctorId} />
                      </Box>
                    </UseStyled.DentistList>
                  )
                }}
                onchange={() => {
                  return
                }}
                noOptionsText={t('NOT_FOUND')}
                filterOptions={(option) => option.fullname}
                value={_.find(props.doctors, { userId: doctorId }) || null}
                disableClearable
                disabled={isEdit === '0' || props.type === 'RetrospectiveEdit' ? true : false}
              />
            </Box>
          </Box>
        </Grid>
        <Grid item xs={6} className="w-100">
          <Box className="d-flex align-items-center">
            <UseStyled.Title className="d-inline-block pr-2">{t('TREATMENT_SUMMARY.TITLE.DISCOUNT')}</UseStyled.Title>
            <Typography>
              {numberFormat(props.discount || 0)} {t('CURRENCY_CHANGE.TH')}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={6} className="w-100">
          <Box className="d-flex align-items-center">
            <UseStyled.Title className="d-inline-block pr-2">{t('TREATMENT_SUMMARY.TITLE.ADDON')}</UseStyled.Title>
            <Typography>
              {numberFormat(props.additional || 0)} {t('CURRENCY_CHANGE.TH')}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} className="w-100">
          <Box className="d-flex align-items-center">
            <UseStyled.Title className="d-inline-block pr-2">{t('TREATMENT_SUMMARY.TITLE.TOTAL')}</UseStyled.Title>
            <Box sx={{ position: 'relative' }}>
              {((props?.data?.promotion?.length || props?.data?.voucher?.voucherListId) && props.data?.fullPrice && (Number(props.data?.fullPrice) !== Number(cal_sum(newData, props.total, 'total')))) ?
                <Box color={'#808080'} fontSize={'12px'} sx={{ textDecorationLine: 'line-through' }}>{numberFormat(props.data?.fullPrice)}</Box>
                : <></>
              }
              <Typography lineHeight="20.8px" fontSize="16px" fontWeight={400}>{numberFormat(newData?.installment ? _.find(newData?.installment?.installmentList, (item) => item.status === 'PENDING')?.price : cal_sum(newData, props.total, 'total'))} {t('CURRENCY_CHANGE.TH')}</Typography>
              {newData?.installment && <Typography lineHeight="15.6px" fontSize="12px" fontWeight={400} color="#808080">แบ่งชำระ: ({_.filter(newData.installment?.installmentList, (item) => item.status === 'PAID')?.length + 1}/{newData.installment?.installmentList?.length})</Typography>}
            </Box>

          </Box>
        </Grid>
        <Grid item xs={12} className="w-100">
          <Box className="w-100 d-flex flex-column flex-sm-row">
            <UseStyled.Title className="d-inline-block pr-2">{t('TREATMENT_SUMMARY.POPUP.COMMISSION.COMMISSION')}</UseStyled.Title>
            <div>
              <ButtonCustom
                onClick={() => {
                  if (props.handleCommission) {
                    props?.handleCommission(props.data, props.hasCommission, props?.no)
                  } else return
                }}
                disabled={isEdit === '0' || props.type === 'RetrospectiveEdit' || props.data?.operativeTypeNameEn === 'NHSO'}
                style={{
                  width: i18n.language === 'th' ? "64px" : "100%",
                  height: i18n.language === 'th' ? "25px" : "100%",
                  '&.MuiButton-contained': {
                    padding: "0px !important",
                    height: '100%', width: '100%'
                  }
                }}
                textButton={t('TREATMENT_SUMMARY.POPUP.COMMISSION.COMMISSION')}
              />
              {(props?.commission && props?.commission !== 0 && (
                <div style={{ fontSize: '12px', color: '#929292', marginTop: '1px' }}>
                  {numberFormat(props?.commission)} {t('CURRENCY_CHANGE.TH')}
                </div>
              )) || <></>}
            </div>
          </Box>
        </Grid>
        <Grid item xs={12} className={`w - 100 ${!operativeTypeId ? 'pb-2' : ''} ${isEdit === '0' ? 'pe-none' : ''} `}>
          <Box className="w-100 d-flex flex-column flex-sm-row">
            <UseStyled.Title className="d-inline-block pr-2">{t('TREATMENT_SUMMARY.TITLE.MORE_INFO')}</UseStyled.Title>
            <Box className="d-flex w-100 mt-2 mt-sm-0">
              <UseStyled.InputFormControl className="pl-sm-2 d-flex position-relative" sx={{ flex: 1 }}>
                <TextareaAutosize
                  name="note"
                  disabled={props.hasChangeTreatmentNote === 'UNPERMISS' || isEdit === '0' ? true : false}
                  className={`input-form-note ${props.hasChangeTreatmentNote === 'UNPERMISS' || isEdit === '0' ? 'disabled' : ''} `}
                  value={note}
                  onChange={props.onChange}
                  minRows={2}
                  maxRows={10}
                  maxLength={props?.data?.operativeTypeNameEn === 'NHSO' ? 1000 : 999999}
                />
                <Box className="input-form-note-wrap position-absolute"></Box>
                <ButtonCustom
                  disabled={props.hasChangeTreatmentNote === 'UNPERMISS' || isEdit === '0' ? true : false}
                  onClick={props.onViewMessage}
                  textButton={<img src={icons.iconFeatherEdit} alt="" style={{ width: 24 }} />}
                  className="h-100"
                  style={{ margin: 0, height: '100%' }}
                />
              </UseStyled.InputFormControl>
              {(props.errorMessage?.note && !note) && <Box paddingLeft={1}><HelperText label={props.errorMessage?.note} /></Box>}
            </Box>
          </Box>
        </Grid>
        {operativeTypeId && (
          <Grid item xs={12} className="w-100 pb-2">
            <Box className="w-100 d-flex flex-column flex-sm-row">
              <UseStyled.Title className="d-inline-block pr-2">{t('Next visit')}</UseStyled.Title>
              <Box className="d-flex w-100 mt-2 mt-sm-0">
                <UseStyled.InputFormControl className="pl-sm-2 d-flex position-relative next-visit" sx={{ flex: 1 }}>
                  <TextareaAutosize name="noteNextVisit" className={`input-form-note ${isEdit === '0' ? 'pe-none disabled' : ''}`} value={noteNextVisit} onChange={props.onChange} minRows={2} maxRows={10} />
                  <Box className="input-form-note-wrap position-absolute"></Box>
                  <ButtonCustom
                    onClick={props.onViewNextVisit}
                    textButton={<img src={icons.iconCalendarPlus} alt="" style={{ width: 28 }} />}
                    className="h-100"
                    style={{ margin: 0, height: '100%' }}
                    disabled={(isEdit === '0' || props?.hasEditNextVisit) ? true : false} />
                </UseStyled.InputFormControl>
              </Box>
            </Box>
            {(!_.isEmpty(nextVisit) && (
              <Box className="w-100 d-flex flex-column flex-sm-row">
                <UseStyled.Title className="d-none d-sm-inline-block pr-2" sx={{ flex: 'none', opacity: 0 }}>
                  {t('Next visit')}
                </UseStyled.Title>
                <Typography className="mt-2">
                  <span style={{ fontWeight: 600 }}>{t('TREATMENT_SUMMARY.TITLE.APPOINTMENT')} :</span>
                  <span className="ml-1" style={{ color: colors.textLightGray }}>{`${t('TREATMENT_SUMMARY.POPUP.TREATMENT_NEXT_VISIT.TEMPLATE_MESSAGE.NEXT_VISIT', {
                    date: nextVisit?.date ? toBuddhistYear(moment(nextVisit?.date), 'DD/MM/YYYY') : '-',
                    time: nextVisit?.timeStart ? toBuddhistYear(moment(nextVisit.timeStart, 'HH:mm'), 'HH:mm') : '-',
                    dentist: _.get(_.find(props.doctors, { userId: nextVisit?.doctorId }), 'fullname'),
                    treatment: props.renderTreatmentNextVisit
                  })}`}</span>
                </Typography>
              </Box>
            )) || <></>}
          </Grid>
        )}
      </Grid>
    </>
  )
}

export const cal_sum = (data: any, rawData: any, status: string) => {
  if (data.group !== 'MEDICINE') {
    return rawData
  } else {

    const promotion = data?.promotionDiscountUnit === 'BAHT' ? data?.promotionDiscount || 0 : data.price * data.qty * ((data?.promotionDiscount || 0) / 100)
    const voucher = data?.voucherDiscountUnit === 'BAHT' ? data?.voucherDiscount || 0 : data.price * data.qty * ((data?.voucherDiscount || 0) / 100)
    const discount = data.discountUnit === 'BAHT' ? data.discount : data.price * data.qty * (data.discount / 100)
    const additional = data.additionalUnit === 'BAHT' ? data.additional : data.price * data.qty * (data.additional / 100)
    const total = (data.price * data.qty - discount + additional) - (promotion + voucher)
    if (status === 'discount') {
      return discount
    }
    if (status === 'additional') {
      return additional
    }
    if (status === 'total') {
      return total
    }
  }
}

export const renderSumDiscount = (value: any) => {
  if (value?.approvalItems?.status === ApprovalStatus.PENDING) {
    value = JSON.parse(value?.approvalItems?.body)
  }

  const price = Number(value.price)
  const qty = Number(value.qty)
  const newNormalPrice = value.installment ? price : price * qty
  const rawDiscount = Number(value.discount)
  const rawDiscountUnit = value.discountUnit
  const rawAdditional = Number(value.additional)
  const rawAdditionalUnit = value.additionalUnit

  const newOpPromotion: any = {}
  // const newOpPromotion = promotionOperative?.length ? promotionOperative?.find((item: any) => item?.isMain === '1') : {}
  const rawPromotionPriceType = newOpPromotion?.promotionPriceType || ""
  const rawPromotionUsage = newOpPromotion?.promotionUsage || ""
  const rawPromotionDiscount = Number(newOpPromotion?.promotionPrice || 0)
  const rawPromotionDiscountUnit = newOpPromotion?.promotionPriceUnit || CURRENCY_UNIT.BAHT

  const voucher: any = value?.voucher
  const rawVoucherPriceType = voucher?.voucherPriceType || ""
  const rawVoucherUsage = voucher?.voucherUsage || ""
  const rawVoucherDiscount = Number(voucher?.voucherPrice || 0)
  const rawVoucherDiscountUnit = voucher?.voucherPriceUnit || CURRENCY_UNIT.BAHT

  let rawDiscountAmount = 0
  let rawAdditionalAmount = 0
  let rawPromotionDiscountAmount = 0
  let rawVoucherDiscountAmount = 0

  /** คำนวน ส่วนลดส่วนเพิ่มจากราคาเต็ม */

  /** ส่วนลด ทั่วไป */
  if (rawDiscountUnit === CURRENCY_UNIT.PERCENT) rawDiscountAmount = newNormalPrice * (rawDiscount / 100)
  if (rawDiscountUnit === CURRENCY_UNIT.BAHT) rawDiscountAmount = rawDiscount

  /** ส่วนเพิ่ม */
  if (rawAdditionalUnit === CURRENCY_UNIT.PERCENT) rawAdditionalAmount = newNormalPrice * (rawAdditional / 100)
  if (rawAdditionalUnit === CURRENCY_UNIT.BAHT) rawAdditionalAmount = rawAdditional

  /** ส่วนลด Promotion */
  if (rawPromotionDiscountUnit === CURRENCY_UNIT.PERCENT) rawPromotionDiscountAmount = newNormalPrice * (rawPromotionDiscount / 100)
  if (rawPromotionDiscountUnit === CURRENCY_UNIT.BAHT) rawPromotionDiscountAmount = rawPromotionDiscount

  /** ส่วนลด Voucher */
  if (rawVoucherPriceType === 'DISCOUNT' && rawVoucherDiscountUnit === CURRENCY_UNIT.PERCENT) rawVoucherDiscountAmount = newNormalPrice * (rawVoucherDiscount / 100)
  if (rawVoucherPriceType === 'DISCOUNT' && rawVoucherDiscountUnit === CURRENCY_UNIT.BAHT) rawVoucherDiscountAmount = rawVoucherDiscount

  if (rawVoucherPriceType === 'SALEPRICE') rawVoucherDiscountAmount = newNormalPrice - rawVoucherDiscount


  /** 
   *? ราคาหลังหักส่วนลด-ส่วนเพิ่ม 
   */
  const newAmount = newNormalPrice - rawDiscountAmount + rawAdditionalAmount
  const fullPrice = newAmount
  let newDF = 0
  let newCF = 0
  const total = newAmount
  let dfAmount = value.dfAmount;
  let cfAmount = value.cfAmount
  let dfUnit = value.dfUnit

  let valueDf = 0
  let valueCf = 0
  let dfPromotionDiscountAmount = 0
  let cfPromotionDiscountAmount = 0
  let dfVoucherDiscountAmount = 0
  let cfVoucherDiscountAmount = 0
  const hasNoDf = "1"
  /** ได้ DF CF จากราคาสุทธิ (คิด ส่วนลด-ส่วนเพิ่ม)  */
  /** 
   *? คำนวน DF
   *? กรณี หัตถการเฉพาะ DF
   *? กรณี หัตถการเฉพาะ CF
   *? หัตถการทั้ง DF และ CF
   */
  if (price === 0) {
    return 0

  } else {
    if (value.dfUnit === CURRENCY_UNIT.PERCENT) {
      const sumDf = total * (value.dfAmount / 100)
      const sumCf = total * (value.cfAmount / 100)
      newDF = sumDf
      newCF = sumCf
      valueDf = sumDf
      valueCf = sumCf

      dfAmount = value.dfAmount
      cfAmount = value.cfAmount
      dfUnit = value.dfUnit
    } else {
      newDF = value.dfAmount * qty
      newCF = total - (value.dfAmount * qty)
      const newValueDf = (total <= 0 && hasNoDf) ? 0 : newDF
      valueDf = newValueDf
      valueCf = newCF

      dfAmount = value.dfAmount
      cfAmount = value.cfAmount
      dfUnit = value.dfUnit
    }
    let rawDfDiscountAmount = 0
    let rawCfDiscountAmount = 0

    if (value.dfDiscountUnit === CURRENCY_UNIT.PERCENT) {
      rawDfDiscountAmount = (Number(valueDf) * Number(value.dfDiscountAmount)) / 100
    } else if (value.dfDiscountUnit === CURRENCY_UNIT.BAHT) {
      rawDfDiscountAmount = Number(value.dfDiscountAmount)
    }

    if (value.cfDiscountUnit === CURRENCY_UNIT.PERCENT) {
      rawCfDiscountAmount = (Number(valueCf) * Number(value.cfDiscountAmount)) / 100
    } else if (value.cfDiscountUnit === CURRENCY_UNIT.BAHT) {
      rawCfDiscountAmount = Number(value.cfDiscountAmount)
    }

    /** Promotion */
    if (rawPromotionPriceType === "DISCOUNT") {
      if (rawPromotionDiscountAmount > 0 && rawPromotionUsage === 'OPERATIVEDF') {
        dfPromotionDiscountAmount = rawPromotionDiscountAmount
      }
      if (rawPromotionDiscountAmount > 0 && rawPromotionUsage === 'OPERATIVECF') {
        cfPromotionDiscountAmount = rawPromotionDiscountAmount
      }

      if (rawPromotionDiscountAmount > 0 && rawPromotionUsage === 'OPERATIVE') {
        dfPromotionDiscountAmount = ((valueDf / total) * rawPromotionDiscountAmount)
        cfPromotionDiscountAmount = ((valueCf / total) * rawPromotionDiscountAmount)
      }
    }


    /** Voucher */
    if (rawVoucherDiscountAmount > 0 && rawVoucherUsage === 'OPERATIVEDF') {
      dfVoucherDiscountAmount = rawVoucherDiscountAmount
    }

    if (rawVoucherDiscountAmount > 0 && rawVoucherUsage === 'OPERATIVECF') {
      cfVoucherDiscountAmount = rawVoucherDiscountAmount
    }

    if (rawVoucherDiscountAmount > 0 && rawVoucherUsage === 'OPERATIVE') {
      dfVoucherDiscountAmount = ((valueDf / total) * rawVoucherDiscountAmount)
      cfVoucherDiscountAmount = ((valueCf / total) * rawVoucherDiscountAmount)
    }

    return rawDiscountAmount + rawDfDiscountAmount + rawCfDiscountAmount + dfPromotionDiscountAmount + cfPromotionDiscountAmount + dfVoucherDiscountAmount + cfVoucherDiscountAmount
  }
}

export const renderSumAdditional = (value: RawAdditionalType) => {
  const additional = value.additionalUnit === 'PERCENT' ? (value.price * value.qty * value.additional) / 100 : value.additional
  return additional
}

export const doctorHasOverDue = (treatments: TreatmentStateInterface, doctorId: number | null) => {
  const hasOverdue = _.some(treatments?.summeryTreatments, { isEdit: '0', doctorId: _.get(treatments?.summeryTreatments[0], 'pinDoctorId') || doctorId })
  const branchInfo = getClinicInfo()
  return branchInfo?.pdfInvoiceTreatmentCondition === '0' ? hasOverdue : false
}

interface UpdateDFValueInterface {
  operativeId: number
  doctorId: number
  price: number
  qty: number
  discount: number
  discountUnit: string
  additional: number
  additionalUnit: string
  dfAmount: number
  dfUnit: string
  dfDiscountAmount: number
  dfDiscountUnit: string
  cfDiscountAmount: number
  cfDiscountUnit: string
}
export async function updateDFValue(props: any) {

  const hasNoDf = props.hasNoDf
  const operative = props
  const condition: FindDoctorFeeProps = {
    operativeId: props.operativeId,
    branchId: Number(getBranch()),
    doctorId: props.doctorId
  }
  const resp = await TreatmentApi.findDoctorFee(condition)

  if (resp.status === 200) {
    const doctorFee = resp.data
    const price = Number(operative.price)
    const qty = Number(operative.qty)
    const newNormalPrice = operative.installment ? price : price * qty
    const rawDiscount = Number(operative.discount)
    const rawDiscountUnit = operative.discountUnit
    const rawAdditional = Number(operative.additional)
    const rawAdditionalUnit = operative.additionalUnit

    const newOpPromotion: any = {}
    // const newOpPromotion = promotionOperative?.length ? promotionOperative?.find((item: any) => item?.isMain === '1') : {}
    const rawPromotionPriceType = newOpPromotion?.promotionPriceType || ""
    const rawPromotionUsage = newOpPromotion?.promotionUsage || ""
    const rawPromotionDiscount = Number(newOpPromotion?.promotionPrice || 0)
    const rawPromotionDiscountUnit = newOpPromotion?.promotionPriceUnit || CURRENCY_UNIT.BAHT

    const voucher: any = operative?.voucher
    const rawVoucherPriceType = voucher?.voucherPriceType || ""
    const rawVoucherUsage = voucher?.voucherUsage || ""
    const rawVoucherDiscount = Number(voucher?.voucherPrice || 0)
    const rawVoucherDiscountUnit = voucher?.voucherPriceUnit || CURRENCY_UNIT.BAHT

    let rawDiscountAmount = 0
    let rawAdditionalAmount = 0
    let rawPromotionDiscountAmount = 0
    let rawVoucherDiscountAmount = 0

    /** คำนวน ส่วนลดส่วนเพิ่มจากราคาเต็ม */

    /** ส่วนลด ทั่วไป */
    if (rawDiscountUnit === CURRENCY_UNIT.PERCENT) rawDiscountAmount = newNormalPrice * (rawDiscount / 100)
    if (rawDiscountUnit === CURRENCY_UNIT.BAHT) rawDiscountAmount = rawDiscount

    /** ส่วนเพิ่ม */
    if (rawAdditionalUnit === CURRENCY_UNIT.PERCENT) rawAdditionalAmount = newNormalPrice * (rawAdditional / 100)
    if (rawAdditionalUnit === CURRENCY_UNIT.BAHT) rawAdditionalAmount = rawAdditional

    /** ส่วนลด Promotion */
    if (rawPromotionDiscountUnit === CURRENCY_UNIT.PERCENT) rawPromotionDiscountAmount = newNormalPrice * (rawPromotionDiscount / 100)
    if (rawPromotionDiscountUnit === CURRENCY_UNIT.BAHT) rawPromotionDiscountAmount = rawPromotionDiscount

    /** ส่วนลด Voucher */
    if (rawVoucherPriceType === 'DISCOUNT' && rawVoucherDiscountUnit === CURRENCY_UNIT.PERCENT) rawVoucherDiscountAmount = newNormalPrice * (rawVoucherDiscount / 100)
    if (rawVoucherPriceType === 'DISCOUNT' && rawVoucherDiscountUnit === CURRENCY_UNIT.BAHT) rawVoucherDiscountAmount = rawVoucherDiscount

    if (rawVoucherPriceType === 'SALEPRICE') rawVoucherDiscountAmount = newNormalPrice - rawVoucherDiscount


    /** 
     *? ราคาหลังหักส่วนลด-ส่วนเพิ่ม 
     */
    let newAmount = newNormalPrice - rawDiscountAmount + rawAdditionalAmount
    const fullPrice = newAmount
    let newDF = 0
    let newCF = 0
    const total = newAmount
    let dfAmount = doctorFee.dfAmount;
    let cfAmount = doctorFee.cfAmount
    let doctorFeeAmount = doctorFee.dfAmount
    let clinicFeeAmount = doctorFee.cfAmount
    let dfUnit = doctorFee.dfUnit
    let cfUnit = doctorFee.cfUnit
    let dfAmounNet = doctorFee.dfAmounNet

    let valueDf = 0
    let valueCf = 0
    let dfPromotionDiscountAmount = 0
    let cfPromotionDiscountAmount = 0
    let dfVoucherDiscountAmount = 0
    let cfVoucherDiscountAmount = 0

    /** ได้ DF CF จากราคาสุทธิ (คิด ส่วนลด-ส่วนเพิ่ม)  */
    /** 
     *? คำนวน DF
     *? กรณี หัตถการเฉพาะ DF
     *? กรณี หัตถการเฉพาะ CF
     *? หัตถการทั้ง DF และ CF
     */
    let dfAmountNet = 0
    let cfAmountNet = 0
    if (price === 0 && doctorFee.dfUnit !== CURRENCY_UNIT.PERCENT) {
      const sumDf = doctorFee.dfAmount
      newDF = sumDf
      newCF = 0

      const newValueDf = (total <= 0 && hasNoDf) ? 0 : sumDf * qty
      valueDf = newValueDf
      valueCf = 0

      dfAmounNet = sumDf * qty
      dfAmount = sumDf
      cfAmount = 0
      doctorFeeAmount = sumDf
      clinicFeeAmount = 0
      dfUnit = doctorFee.dfUnit

      dfAmountNet = dfAmounNet > 0 ? dfAmounNet : 0
      cfAmountNet = 0
    } else {


      if (doctorFee.dfUnit === CURRENCY_UNIT.PERCENT) {
        const sumDf = total * (doctorFee.dfAmount / 100)
        const sumCf = total * (doctorFee.cfAmount / 100)
        newDF = sumDf
        newCF = sumCf
        valueDf = sumDf
        valueCf = sumCf

        dfAmount = doctorFee.dfAmount
        cfAmount = doctorFee.cfAmount
        doctorFeeAmount = valueDf
        clinicFeeAmount = valueCf
        dfUnit = doctorFee.dfUnit
      } else {
        newDF = doctorFee.dfAmount * qty
        newCF = total - (doctorFee.dfAmount * qty)
        const newValueDf = (total <= 0 && hasNoDf) ? 0 : newDF
        valueDf = newValueDf
        valueCf = newCF

        dfAmount = doctorFee.dfAmount
        cfAmount = doctorFee.cfAmount
        doctorFeeAmount = valueDf
        clinicFeeAmount = valueCf
        dfUnit = doctorFee.dfUnit
        cfUnit = doctorFee.cfUnit
      }


      let rawDfDiscountAmount = 0
      let rawCfDiscountAmount = 0

      if (operative.dfDiscountUnit === CURRENCY_UNIT.PERCENT) {
        rawDfDiscountAmount = (Number(valueDf) * Number(operative.dfDiscountAmount)) / 100
      } else if (operative.dfDiscountUnit === CURRENCY_UNIT.BAHT) {
        rawDfDiscountAmount = Number(operative.dfDiscountAmount)
      }

      if (operative.cfDiscountUnit === CURRENCY_UNIT.PERCENT) {
        rawCfDiscountAmount = (Number(valueCf) * Number(operative.cfDiscountAmount)) / 100
      } else if (operative.cfDiscountUnit === CURRENCY_UNIT.BAHT) {
        rawCfDiscountAmount = Number(operative.cfDiscountAmount)
      }

      let dfAmountBaht = valueDf
      let cfAmountBaht = valueCf

      valueDf = valueDf - rawDfDiscountAmount
      valueCf = valueCf - rawCfDiscountAmount
      doctorFeeAmount = doctorFeeAmount - rawDfDiscountAmount
      clinicFeeAmount = clinicFeeAmount - rawCfDiscountAmount

      newAmount = newAmount - rawDfDiscountAmount - rawCfDiscountAmount


      dfAmountNet = valueDf
      cfAmountNet = valueCf


      /** Promotion */

      if (rawPromotionPriceType === "DISCOUNT") {
        if (rawPromotionDiscountAmount > 0 && rawPromotionUsage === 'OPERATIVEDF') {
          dfPromotionDiscountAmount = rawPromotionDiscountAmount

          valueDf = valueDf - rawPromotionDiscountAmount
          doctorFeeAmount = doctorFeeAmount - rawPromotionDiscountAmount

          dfAmountBaht = dfAmountBaht - rawPromotionDiscountAmount
        }
        if (rawPromotionDiscountAmount > 0 && rawPromotionUsage === 'OPERATIVECF') {
          cfPromotionDiscountAmount = rawPromotionDiscountAmount

          valueCf = valueCf - rawPromotionDiscountAmount
          clinicFeeAmount = clinicFeeAmount - rawPromotionDiscountAmount

          cfAmountBaht = cfAmountBaht - rawPromotionDiscountAmount
        }

        if (rawPromotionDiscountAmount > 0 && rawPromotionUsage === 'OPERATIVE') {

          dfPromotionDiscountAmount = ((valueDf / total) * rawPromotionDiscountAmount)
          cfPromotionDiscountAmount = ((valueCf / total) * rawPromotionDiscountAmount)

          valueDf = valueDf - ((valueDf / total) * rawPromotionDiscountAmount)
          valueCf = valueCf - ((valueCf / total) * rawPromotionDiscountAmount)
          doctorFeeAmount = doctorFeeAmount - ((doctorFeeAmount / total) * rawPromotionDiscountAmount)
          clinicFeeAmount = clinicFeeAmount - ((clinicFeeAmount / total) * rawPromotionDiscountAmount)

          dfAmountBaht = dfAmountBaht - ((dfAmountBaht / total) * rawPromotionDiscountAmount)
          cfAmountBaht = cfAmountBaht - ((cfAmountBaht / total) * rawPromotionDiscountAmount)
        }
      }


      /** Voucher */
      if (rawVoucherDiscountAmount > 0 && rawVoucherUsage === 'OPERATIVEDF') {
        dfVoucherDiscountAmount = rawVoucherDiscountAmount

        valueDf = valueDf - rawVoucherDiscountAmount
        doctorFeeAmount = doctorFeeAmount - rawVoucherDiscountAmount

        dfAmountBaht = dfAmountBaht - rawVoucherDiscountAmount
      }
      if (rawVoucherDiscountAmount > 0 && rawVoucherUsage === 'OPERATIVECF') {
        cfVoucherDiscountAmount = rawVoucherDiscountAmount

        valueCf = valueCf - rawVoucherDiscountAmount
        clinicFeeAmount = clinicFeeAmount - rawVoucherDiscountAmount

      }

      if (rawVoucherDiscountAmount > 0 && rawVoucherUsage === 'OPERATIVE') {

        dfVoucherDiscountAmount = ((valueDf / total) * rawVoucherDiscountAmount)
        cfVoucherDiscountAmount = ((valueCf / total) * rawVoucherDiscountAmount)

        valueDf = valueDf - ((valueDf / total) * rawVoucherDiscountAmount)
        valueCf = valueCf - ((valueCf / total) * rawVoucherDiscountAmount)
        doctorFeeAmount = doctorFeeAmount - ((doctorFeeAmount / total) * rawVoucherDiscountAmount)
        clinicFeeAmount = clinicFeeAmount - ((clinicFeeAmount / total) * rawVoucherDiscountAmount)

      }

      dfAmountNet = valueDf < 0 ? 0 : valueDf
      cfAmountNet = valueCf < 0 ? 0 : valueCf

      newAmount = newAmount - dfPromotionDiscountAmount - cfPromotionDiscountAmount - dfVoucherDiscountAmount - cfVoucherDiscountAmount
      newAmount = newAmount > 0 ? newAmount : 0


    }
    return await {
      promotionDiscount: rawPromotionUsage === 'OPERATIVE' ? rawPromotionDiscount : 0,
      dfPromotionDiscountAmount: rawPromotionUsage === 'OPERATIVE' ? 0 : dfPromotionDiscountAmount,
      cfPromotionDiscountAmount: rawPromotionUsage === 'OPERATIVE' ? 0 : cfPromotionDiscountAmount,
      voucherDiscount: rawVoucherUsage === 'OPERATIVE' ? rawVoucherDiscount : 0,
      dfVoucherDiscountAmount: rawVoucherUsage === 'OPERATIVE' ? 0 : dfVoucherDiscountAmount,
      cfVoucherDiscountAmount: rawVoucherUsage === 'OPERATIVE' ? 0 : cfVoucherDiscountAmount,
      dfAmount: doctorFee.dfAmount,
      cfAmount: doctorFee.cfAmount,
      dfUnit: doctorFee.dfUnit,
      dfAmountNet: (total <= 0 && props.hasNoDf) ? 0 : (dfAmountNet > 0 ? dfAmountNet : 0),
      cfAmountNet: cfAmountNet > 0 ? cfAmountNet : 0,
      total: newAmount
    }
  }

  return false
}
export async function updateDFNsho(props: any) {
  const list = _.filter(props.list, (d) => d.price)

  const newData = []
  const maxPrice = 700
  let usePrice = 0
  let indexChangePrice = 1
  const price = Number((maxPrice / list.length).toFixed(2))
  for (let i = 0; i < props.list.length; i++) {
    let dataUpdate = { ...props.list[i] }
    if (!dataUpdate.price) newData.push(dataUpdate)
    else {
      if (dataUpdate.price !== 700) {
        dataUpdate.price = 700
        const updateDF: UpdateDFIF | boolean = await updateDFValue({ ...dataUpdate, hasNoDf: props?.hasNoDf || false })
        if (updateDF)
          dataUpdate = {
            ...dataUpdate,
            total: updateDF.total,
            dfAmount: updateDF.dfAmount,
            dfUnit: updateDF.dfUnit,
            cfAmount: updateDF.cfAmount,
            dfAmountNet: updateDF.dfAmountNet,
            cfAmountNet: updateDF.cfAmountNet,
            doctorFeeAmount: updateDF.dfAmount,
            clinicFeeAmount: updateDF.cfAmount,
            promotionDiscount: updateDF.promotionDiscount,
            dfPromotionDiscountAmount: updateDF.dfPromotionDiscountAmount,
            cfPromotionDiscountAmount: updateDF.cfPromotionDiscountAmount,
            voucherDiscount: updateDF.voucherDiscount,
            dfVoucherDiscountAmount: updateDF.dfVoucherDiscountAmount,
            cfVoucherDiscountAmount: updateDF.cfVoucherDiscountAmount,
          }
      }

      // price
      // total
      // dfAmount
      // dfAmountNet
      // dfUnit
      // cfAmount
      // cfAmountNet

      dataUpdate.price = price
      if (indexChangePrice === list.length) dataUpdate.price = maxPrice - usePrice

      if (dataUpdate.dfUnit === CURRENCY_UNIT.BAHT) {
        dataUpdate.dfAmount = (dataUpdate.dfAmountNet / dataUpdate.total) * dataUpdate.price
        dataUpdate.dfAmountNet = (dataUpdate.dfAmountNet / dataUpdate.total) * dataUpdate.price

        dataUpdate.cfAmount = (dataUpdate.cfAmountNet / dataUpdate.total) * dataUpdate.price
        dataUpdate.cfAmountNet = (dataUpdate.cfAmountNet / dataUpdate.total) * dataUpdate.price

      } else {
        dataUpdate.dfAmount = dataUpdate.price * (dataUpdate.dfAmount / 100)
        dataUpdate.dfAmountNet = dataUpdate.price * (dataUpdate.dfAmount / 100)

        dataUpdate.cfAmount = dataUpdate.price * (dataUpdate.cfAmount / 100)
        dataUpdate.cfAmountNet = dataUpdate.price * (dataUpdate.cfAmount / 100)
      }

      dataUpdate.total = dataUpdate.price


      newData.push(dataUpdate)
      indexChangePrice++
    }

    usePrice += dataUpdate.price
  }

  return newData
}
